import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { Modal, Toast, Offcanvas, Badge } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Api from '../Auth/Api';
import Table from '../Components/Table';
import { useForm, Controller } from 'react-hook-form';
import { pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import GerarPDF from '../Components/GerarPDF';
import GerarCertificado from '../Components/GerarCertificado';
import { useAjustes } from '../Context/AjustesContext';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { decodeJWT } from '../Components/jwtUtils';
import Select from 'react-select';
import { customStyles } from '../utils/selectStyles';
import { DEFAULT_LISTA_TIPO, DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from '../utils/paginationDefaults';

function ListaAlunos() {

    const [showModalNotasInd, setShowModalNotasInd] = useState(false);
    const [showModalEnviarProva, setShowModalEnviarProva] = useState(false);
    const [showModalNota, setShowModalNota] = useState({ show: false });
    const [toast, setToast] = useState({});
    const [showToast, setShowToast] = useState(false);
    const [usuarioSelecionado, setUsuarioSelecionado] = useState({});
    const [progressoAvaliacao, setProgressoAvaliacao] = useState('');
    const [shouldGeneratePDF, setShouldGeneratePDF] = useState({ show: false });
    const [progressoAvaliacaoUserID, setProgressoAvaliacaoUserID] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState(null);
    const [selectedTipo, setSelectedTipo] = useState(DEFAULT_LISTA_TIPO);
    const [selectedStatus, setSelectedStatus] = useState('todos');
    const [globalFilter, setGlobalFilter] = useState('');
    const [showDrawerFiltros, setShowDrawerFiltros] = useState(false);
    const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

    // Form para Notas
    const {
        register: registerNota,
        handleSubmit: handleSubmitNota,
        formState: { errors: errorsNota }
    } = useForm();

    // Form para Prática
    const {
        register: registerPratica,
        handleSubmit: handleSubmitPratica,
        formState: { errors: errorsPratica },
        control: controlPratica,
        reset: resetPratica
    } = useForm({
        defaultValues: {
            data_treinamento: '',
            local_treinamento: '',
            gestor: '',
            lista_presenca: null,
            fotos: null
        }
    });

    // Form para Prática em Massa
    const {
        register: registerPraticaMassa,
        handleSubmit: handleSubmitPraticaMassa,
        formState: { errors: errorsPraticaMassa },
        control: controlPraticaMassa,
        reset: resetPraticaMassa
    } = useForm({
        defaultValues: {
            data_treinamento: '',
            local_treinamento: '',
            gestor: '',
            lista_presenca: null,
            fotos: null
        }
    });

    // Form para Reinicialização Forçada
    const {
        register: registerReiniciarForcado,
        handleSubmit: handleSubmitReiniciarForcado,
        formState: { errors: errorsReiniciarForcado },
        reset: resetReiniciarForcado
    } = useForm({
        defaultValues: {
            justificativa: ''
        }
    });

    const [checkedStates, setCheckedStates] = useState({});
    const [loading, setLoading] = useState(true);
    const [showModalPratica, setShowModalPratica] = useState(false);
    const [showModalVisualizarPratica, setShowModalVisualizarPratica] = useState(false);
    const [praticaAtual, setPraticaAtual] = useState(null);
    const [praticasRegistradas, setPraticasRegistradas] = useState({});
    const [listaPresencaSelected, setListaPresencaSelected] = useState(false);
    const [fotosSelected, setFotosSelected] = useState(false);
    const [listaPresencaEditSelected, setListaPresencaEditSelected] = useState(false);
    const [fotosEditSelected, setFotosEditSelected] = useState(false);
    const [arquivosSelecionados, setArquivosSelecionados] = useState({
        listaPresenca: null,
        fotos: []
    });
    const [showModalConfirmacao, setShowModalConfirmacao] = useState(false);
    const [usuarioConfirmacao, setUsuarioConfirmacao] = useState(null);
    const [novoStatusCertificado, setNovoStatusCertificado] = useState(false);
    const [showModalEditarPratica, setShowModalEditarPratica] = useState(false);
    const [showModalConfirmacaoDeletar, setShowModalConfirmacaoDeletar] = useState(false);
    const [modalVerAvaliacaoReacao, setModalVerAvaliacaoReacao] = useState({ show: false, tipo: '', data: null });
    const [modalError, setModalError] = useState({ show: false, message: '' });
    const [shouldReopenDetailsModal, setShouldReopenDetailsModal] = useState(false);
    const [loadingRegistrar, setLoadingRegistrar] = useState(false);
    const [loadingEditar, setLoadingEditar] = useState(false);
    const [showModalPraticaMassa, setShowModalPraticaMassa] = useState(false);
    const [alunosSelecionadosMassa, setAlunosSelecionadosMassa] = useState([]);
    const [listaPresencaMassaSelected, setListaPresencaMassaSelected] = useState(false);
    const [fotosMassaSelected, setFotosMassaSelected] = useState(false);
    const [loadingRegistrarMassa, setLoadingRegistrarMassa] = useState(false);
    const [showModalHistorico, setShowModalHistorico] = useState(false);
    const [historicoAluno, setHistoricoAluno] = useState(null);
    const [loadingHistorico, setLoadingHistorico] = useState(false);
    const [tabAtivaHistorico, setTabAtivaHistorico] = useState('aulas');
    const [showModalReiniciarForcado, setShowModalReiniciarForcado] = useState(false);
    const [loadingReiniciarForcado, setLoadingReiniciarForcado] = useState(false);
    const [cursoReiniciarForcado, setCursoReiniciarForcado] = useState(null);


    const navigate = useNavigate();
    const token = JSON.parse(localStorage.getItem("user_token"));
    const usuarioLogado = decodeJWT(token);
    const nivel = usuarioLogado.nivel;
    const idUsuarioLogado = usuarioLogado.idUsuario;
    const isAdminOrRH = nivel === 'Administrador' || nivel === 'RH';
    const { id } = useParams();
    const { ajustes } = useAjustes();

    const handleSwitchChange = useCallback(async (idUsuario, novoStatus) => {
        setUsuarioConfirmacao(idUsuario);
        setNovoStatusCertificado(novoStatus);
        setShowModalConfirmacao(true);
    }, []);

    // Função para gerar e enviar PDF automaticamente após habilitar certificado
    const gerarEEnviarPdfCertificado = useCallback(async (idCertificado) => {
        try {
            // Buscar dados completos do certificado
            const response = await Api.get(`api/info-certificado/${idCertificado}`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            const certificadoData = response.data[0];
            if (!certificadoData) {
                return;
            }

            // Determinar data do certificado
            let dataParaCertificado = certificadoData.data;
            if (certificadoData.tipo === 'misto') {
                if (certificadoData.data_pratica) {
                    dataParaCertificado = certificadoData.data_pratica;
                } else {
                    try {
                        const praticasResponse = await Api.get(`api/cursos/${certificadoData.idCurso}/praticas?arquivadas=false`, {
                            headers: { Authorization: `Bearer ${token}` }
                        });
                        const praticaUsuario = praticasResponse.data.find(
                            p => p.idUsuario === certificadoData.idUsuario
                        );
                        if (praticaUsuario && praticaUsuario.data_treinamento) {
                            dataParaCertificado = praticaUsuario.data_treinamento;
                        }
                    } catch (error) {
                        // Erro ao buscar prática, continua com data padrão
                    }
                }
            } else if (certificadoData.data_avaliacao) {
                dataParaCertificado = certificadoData.data_avaliacao;
            }

            // Gerar PDF
            const blob = await pdf(
                <GerarCertificado
                    data={{
                        id: certificadoData.id,
                        nomeAluno: certificadoData.nomeAluno,
                        cpf: certificadoData.cpf,
                        prazo_validade: certificadoData.prazo_validade,
                        nomeCurso: certificadoData.nomeCurso,
                        data: dataParaCertificado,
                        nomeGestor: certificadoData.nomeGestor,
                        certificado: certificadoData.certificado,
                        certificado_frente: certificadoData.certificado_frente,
                        nomeTopico: certificadoData.nomeTopico,
                        cargaHorariaTotal: certificadoData.cargaHorariaTotal,
                        unidade: certificadoData.unidade
                    }}
                    diplomaUrl={ajustes?.diploma || null}
                    empresa={ajustes?.titulo || "Empresa"}
                    textoCertificado={ajustes?.texto_certificado || null}
                />
            ).toBlob();

            // Criar FormData para enviar o PDF
            const formData = new FormData();
            formData.append('arquivo', blob, 'certificado.pdf');

            // Enviar para o backend
            await Api.post(`api/certificado/upload-pdf/${idCertificado}`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
        } catch (error) {
            // Erro silencioso - não interrompe o fluxo do usuário
        }
    }, [token, ajustes]);

    const confirmarMudancaCertificado = useCallback(async () => {
        try {
            const response = await Api.post(`api/permissao-certificado/${id}/${usuarioConfirmacao}`, {}, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (response && response.data) {
                const novaPermissao = response.data.permissao === 1;

                setCheckedStates(prevState => ({
                    ...prevState,
                    [usuarioConfirmacao]: novaPermissao
                }));

                setToast({
                    header: 'Sucesso!',
                    body: `Certificado ${novoStatusCertificado ? 'liberado' : 'bloqueado'} com sucesso!`,
                    type: 'toast-success'
                });
                setShowToast(true);

                // Se o certificado foi habilitado (permissao = 1), gerar PDF automaticamente
                if (novaPermissao) {
                    const idCertificado = response.data.idCertificado;
                    const temPdf = response.data.temPdf;

                    if (idCertificado && !temPdf) {
                        // Gerar em background (não bloquear a UI)
                        setTimeout(() => {
                            gerarEEnviarPdfCertificado(idCertificado);
                        }, 500);
                    }
                }
            }
        } catch (error) {
            console.error('[confirmarMudancaCertificado] ERRO:', error);
            setToast({
                header: 'Ops!',
                body: error.response?.data?.message || 'Erro ao alterar permissão do certificado',
                type: 'toast-error'
            });
            setShowToast(true);
        }
        setShowModalConfirmacao(false);
    }, [id, token, usuarioConfirmacao, novoStatusCertificado, gerarEEnviarPdfCertificado]);

    const onSubmitReiniciarForcado = useCallback(async (data) => {
        if (!cursoReiniciarForcado || !usuarioSelecionado.id) {
            setToast({
                header: 'Erro!',
                body: 'Dados insuficientes para reiniciar o curso.',
                type: 'toast-error'
            });
            setShowToast(true);
            return;
        }

        setLoadingReiniciarForcado(true);

        try {
            const response = await Api.post('/api/admin/reiniciar-curso-forcado', {
                idUsuario: usuarioSelecionado.id,
                idCurso: cursoReiniciarForcado.id,
                justificativa: data.justificativa
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.success) {
                setToast({
                    header: 'Sucesso!',
                    body: response.data.message,
                    type: 'toast-success'
                });
                setShowToast(true);
                setShowModalReiniciarForcado(false);
                resetReiniciarForcado();
                setCursoReiniciarForcado(null);
            }
        } catch (error) {
            console.error('Erro ao reiniciar curso forçado:', error);
            setToast({
                header: 'Erro!',
                body: error.response?.data?.message || 'Erro ao reiniciar curso. Tente novamente.',
                type: 'toast-error'
            });
            setShowToast(true);
        } finally {
            setLoadingReiniciarForcado(false);
        }
    }, [cursoReiniciarForcado, usuarioSelecionado, token, resetReiniciarForcado]);

    const onSubmitNota = async (data) => {

        data['tipo'] = showModalNota.tipo;

        try {
            const response = await Api.post(`/api/editar-nota-avaliacao/${showModalNota.id}`, data, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setToast({ header: 'Sucesso!', body: response.data.message, type: 'toast-success' })

        } catch (error) {
            setToast({ header: 'Ops!', body: error.response.data.message, type: 'toast-error' })
            console.error("Erro ao editar a nota:", error);
        }

        setShowToast(true);
        setShowModalNota({ show: false })
        setShowModalNotasInd(true)
    };

    const onSubmitPratica = async (data) => {
        setLoadingRegistrar(true);
        const formData = new FormData();
        formData.append('data_treinamento', data.data_treinamento);
        formData.append('local_treinamento', data.local_treinamento);
        formData.append('gestor', data.gestor);

        if (data.lista_presenca instanceof FileList) {
            formData.append('lista_presenca', data.lista_presenca[0]);
        }

        if (data.fotos instanceof FileList) {
            for (let i = 0; i < data.fotos.length; i++) {
                formData.append(`fotos[${i}]`, data.fotos[i]);
            }
        }

        try {
            const response = await Api.post(`/api/registrar-pratica/${id}/${usuarioSelecionado.id}`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });

            // Atualizar o estado localmente com a prática recém-registrada
            if (response.data.pratica && response.data.pratica.id) {
                const praticaMap = { ...praticasRegistradas };
                praticaMap[usuarioSelecionado.id] = { ativa: true, id: response.data.pratica.id };
                setPraticasRegistradas(praticaMap);
            }

            setToast({ header: 'Sucesso!', body: response.data.message, type: 'toast-success' });
            setShowModalPratica(false);
            resetPratica();
            setListaPresencaSelected(false);
            setFotosSelected(false);
        } catch (error) {
            setToast({ header: 'Ops!', body: error.response?.data?.message || 'Erro ao registrar prática', type: 'toast-error' });
        } finally {
            setLoadingRegistrar(false);
        }
        setShowToast(true);
    };

    const onSubmitPraticaMassa = async (data) => {
        setLoadingRegistrarMassa(true);
        const formData = new FormData();

        // Adicionar array de IDs dos alunos
        formData.append('idUsuarios', JSON.stringify(alunosSelecionadosMassa.map(a => a.id)));

        // Adicionar dados do treinamento
        formData.append('data_treinamento', data.data_treinamento);
        formData.append('local_treinamento', data.local_treinamento);
        formData.append('gestor', data.gestor);

        // Adicionar arquivos
        if (data.lista_presenca instanceof FileList) {
            formData.append('lista_presenca', data.lista_presenca[0]);
        }

        if (data.fotos instanceof FileList) {
            for (let i = 0; i < data.fotos.length; i++) {
                formData.append(`fotos[${i}]`, data.fotos[i]);
            }
        }

        try {
            const response = await Api.post(`/api/registrar-pratica-massa/${id}`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });

            setToast({ header: 'Sucesso!', body: response.data.message, type: 'toast-success' });
            setShowModalPraticaMassa(false);
            resetPraticaMassa();
            setAlunosSelecionadosMassa([]);
            setListaPresencaMassaSelected(false);
            setFotosMassaSelected(false);

            // Recarregar práticas para atualizar UI
            try {
                const responsePraticas = await Api.get(`/api/cursos/${id}/praticas`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                const praticasMap = {};
                responsePraticas.data.forEach(pratica => {
                    praticasMap[pratica.idUsuario] = {
                        ativa: !pratica.arquivado,
                        id: pratica.id,
                        arquivada: pratica.arquivado
                    };
                });
                setPraticasRegistradas(praticasMap);
            } catch (error) {
                console.error('Erro ao recarregar práticas:', error);
            }
        } catch (error) {
            setToast({ header: 'Ops!', body: error.response?.data?.message || 'Erro ao registrar práticas', type: 'toast-error' });
        } finally {
            setLoadingRegistrarMassa(false);
        }
        setShowToast(true);
    };

    const [dataInfoCurso, setDataInfoCurso] = useState([]);
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`api/info-curso/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataInfoCurso(response.data);
            } catch (error) {
                console.error(error.response.data.message)
                // navigate("/");
            }
        }

        fetchData();
    }, [token, id, navigate]);

    const [alunos, setAlunos] = useState([]);
    useEffect(() => {
        setLoading(true);
        async function fetchData() {
            try {
                const response = await Api.get(`api/listar-usuarios-por-curso/${id}/${selectedTipo}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                // Aqui você inicializa o estado checkedStates
                const initialStates = {};
                response.data.forEach(usuario => {
                    initialStates[usuario.id] = usuario.certificado === 1;
                });
                setCheckedStates(initialStates);
                setLoading(false);
                setAlunos(response.data);
            } catch (error) {
                setLoading(false);
                console.error(error.response.data.message)
            }
        }
        fetchData();
    }, [token, id, navigate, toast, selectedTipo]);

    const filterSelect = [
        { value: 'todos', label: 'Todas' },
        { value: 'andamento', label: 'Em andamento' },
        { value: 'finalizados', label: 'Aulas concluidas' }
    ]

    const filterTipo = [
        { value: 'todos', label: 'Todos os alunos' },
        { value: 'favoritos', label: 'Favoritos' },
    ]

    const filterStatus = [
        { value: 'todos', label: 'Todas as etapas' },
        { value: 'aulas', label: 'Aulas' },
        { value: 'avaliacao', label: 'Avaliação' },
        { value: 'avaliacao_reacao', label: 'Avaliação de Reação' },
        { value: 'concluido', label: 'Concluído' }
    ]

    // Criando os filtros a partir da api do Alunos
    const filterAlunos = useMemo(() => {
        let filtered = alunos;

        // Filtro por status/etapa
        if (selectedStatus && selectedStatus !== 'todos') {
            switch (selectedStatus) {
                case "aulas":
                    filtered = filtered.filter(value => value.etapa_atual === 'Aulas');
                    break;
                case "avaliacao":
                    filtered = filtered.filter(value => value.etapa_atual === 'Avaliação');
                    break;
                case "avaliacao_reacao":
                    filtered = filtered.filter(value =>
                        value.etapa_atual === 'Avaliação de Reação' ||
                        value.etapa_atual === 'Avaliação de Reação Híbrida'
                    );
                    break;
                case "concluido":
                    filtered = filtered.filter(value =>
                        value.etapa_atual === 'Concluído' ||
                        value.status === 'Aprovado'
                    );
                    break;
                default:
                    break;
            }
        }

        // Filtro por progresso
        if (selectedFilter) {
            switch (selectedFilter) {
                case "todos":
                    // Não filtra adicionalmente
                    break;
                case "andamento":
                    filtered = filtered.filter(value => parseInt(value.aulas_finalizadas) > 0 && parseInt(value.porcentagem_concluida) !== 100);
                    break;
                case "finalizados":
                    filtered = filtered.filter(value => parseInt(value.porcentagem_concluida) === 100);
                    break;
                default:
                    break;
            }
        }

        return filtered;
    }, [alunos, selectedStatus, selectedFilter]);

    // Filtrar por busca global
    const filteredAlunosBySearch = useMemo(() => {
        if (!globalFilter) return filterAlunos;
        return filterAlunos.filter(aluno =>
            aluno.nome_completo?.toLowerCase().includes(globalFilter.toLowerCase()) ||
            aluno.codigo?.toLowerCase().includes(globalFilter.toLowerCase()) ||
            aluno.email?.toLowerCase().includes(globalFilter.toLowerCase())
        );
    }, [filterAlunos, globalFilter]);

    useEffect(() => {
        setProgressoAvaliacao('') // Limpa antes de recarregar
        if (shouldGeneratePDF.show && progressoAvaliacao && usuarioSelecionado.id === progressoAvaliacaoUserID) {
            // Verificar se os dados estão completos antes de gerar o PDF
            const temQuestoes = progressoAvaliacao?.questoes && typeof progressoAvaliacao.questoes === 'string'
                ? JSON.parse(progressoAvaliacao.questoes || '{}')
                : progressoAvaliacao?.questoes || {};

            const questoesParsed = typeof temQuestoes === 'string' ? JSON.parse(temQuestoes) : temQuestoes;
            const temDadosCompletos = Object.keys(questoesParsed).length > 0;

            if (temDadosCompletos) {
                // Pequeno delay para garantir que o componente processou os dados
                setTimeout(() => {
                    const doc = <GerarPDF data={progressoAvaliacao} titulo={shouldGeneratePDF.nome} tipo='avaliacao' />;
                    pdf(doc).toBlob().then(blob => {
                        saveAs(blob, `avaliacao_${usuarioSelecionado.nome_completo}_${shouldGeneratePDF.nome}.pdf`);
                        setShouldGeneratePDF({ show: false });  // Reset após gerar o PDF
                    });
                }, 100);
            }
        }
    }, [shouldGeneratePDF, progressoAvaliacao, usuarioSelecionado.nome_completo, usuarioSelecionado.id, progressoAvaliacaoUserID]);

    //Listar avaliacao e respostas do usuario
    useEffect(() => {
        async function fetchData(idUsuario, tipo) {
            try {
                const response = await Api.get(`api/${tipo === 'EX' ? 'info-progresso-avaliacao-extra-usuario' : 'info-progresso-avaliacao-usuario'}/${shouldGeneratePDF.id}/${idUsuario}`, { headers: { Authorization: `Bearer ${token}` } });
                setProgressoAvaliacao(response.data);
                setProgressoAvaliacaoUserID(idUsuario); // Defina o ID do usuário para o qual os dados se aplicam

            } catch (error) {
                console.error(error.response.data.message)
            }
        }
        if (usuarioSelecionado.id && shouldGeneratePDF.id) {
            fetchData(usuarioSelecionado.id, shouldGeneratePDF.tipo);
        }
    }, [usuarioSelecionado.id, id, token, shouldGeneratePDF]);

    const [dataModulos, setDataModulos] = useState([]);
    useEffect(() => {
        async function fetchData() {
            try {
                if (!usuarioSelecionado.id) return; // Evita chamadas desnecessárias

                // Resetar o estado de erro do modal
                setModalError({ show: false, message: '' });

                const response = await Api.get(`api/listar-progresso-avaliacao-curso/${id}/${usuarioSelecionado.id}?incluir_arquivados=1`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataModulos(response.data);
            } catch (error) {
                console.error(error);
                if (error.response && error.response.data && error.response.data.message) {
                    // Mostrar erro dentro do modal em vez de fechar o modal
                    setModalError({
                        show: true,
                        message: error.response.data.message
                    });
                    setDataModulos([]); // Limpa os dados
                } else {
                    // Mostrar erro dentro do modal para outros tipos de erro
                    setModalError({
                        show: true,
                        message: 'Ocorreu um erro ao carregar as avaliações.'
                    });
                }
            }
        }
        if (showModalNotasInd && usuarioSelecionado.id) {
            fetchData();
        }
    }, [id, token, usuarioSelecionado.id, showModalNotasInd])

    const verificarPraticaExistente = useCallback(async (idCurso, idUsuario) => {
        try {
            // Em vez de fazer duas chamadas API para verificar práticas ativas e arquivadas,
            // use os dados que já foram carregados no estado praticasRegistradas
            const praticaInfoMap = praticasRegistradas[idUsuario];

            if (praticaInfoMap) {
                // Se já temos a informação da prática, buscamos apenas os detalhes
                const detalhes = await Api.get(`/api/praticas/${praticaInfoMap.id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setPraticaAtual({ ...detalhes.data, arquivada: !praticaInfoMap.ativa });
                setShowModalVisualizarPratica(true);
            } else {
                // Se não encontrou, abre o modal de registro
                setShowModalPratica(true);
            }
        } catch (error) {
            setToast({
                header: 'Ops!',
                body: error.response?.data?.message || 'Erro ao verificar prática existente',
                type: 'toast-error'
            });
            setShowToast(true);
        }
    }, [token, setPraticaAtual, setShowModalVisualizarPratica, setShowModalPratica, setToast, setShowToast, praticasRegistradas]);

    useEffect(() => {
        async function fetchPraticas() {
            try {
                // Uma única chamada para buscar práticas ativas e arquivadas em paralelo
                const [responseAtivas, responseArquivadas] = await Promise.all([
                    Api.get(`/api/cursos/${id}/praticas`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }),
                    Api.get(`/api/cursos/${id}/praticas?arquivadas=true`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    })
                ]);

                const praticasMap = {};

                // Mapear práticas ativas
                responseAtivas.data.forEach(pratica => {
                    praticasMap[pratica.idUsuario] = { ativa: true, id: pratica.id };
                });

                // Mapear práticas arquivadas
                responseArquivadas.data.forEach(pratica => {
                    // Se o usuário já tem uma prática ativa, não sobreescreve
                    if (!praticasMap[pratica.idUsuario]) {
                        praticasMap[pratica.idUsuario] = { ativa: false, id: pratica.id, arquivada: true };
                    }
                });

                setPraticasRegistradas(praticasMap);
            } catch (error) {
                console.error('Erro ao buscar práticas:', error);
            }
        }

        if (id) {
            fetchPraticas();
        }
    }, [id, token, showModalPratica, showModalVisualizarPratica]);

    // Vamos adicionar uma função para buscar os dados completos do usuário
    const buscarDadosUsuario = useCallback(async (idUsuario) => {
        try {
            const response = await Api.get(`/api/usuario/${idUsuario}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            // Atualiza o usuário selecionado com os dados completos, incluindo gestor_responsavel
            setUsuarioSelecionado(prevState => ({
                ...prevState,
                ...response.data
            }));

            return response.data;
        } catch (error) {
            console.error('Erro ao buscar dados do usuário:', error);
            setToast({
                header: 'Erro!',
                body: 'Não foi possível obter os dados completos do usuário.',
                type: 'toast-error'
            });
            setShowToast(true);
            return null;
        }
    }, [token, setToast]);

    // Modificar o click handler para buscar os dados completos antes de mostrar o modal
    const handleVerNotas = useCallback(async (usuario) => {
        setUsuarioSelecionado(usuario);
        await buscarDadosUsuario(usuario.id);
        setShowModalNotasInd(true);
    }, [buscarDadosUsuario, setUsuarioSelecionado, setShowModalNotasInd]);

    // Função para buscar histórico do aluno
    const handleVerHistorico = useCallback(async (usuario) => {
        setUsuarioSelecionado(usuario);
        setLoadingHistorico(true);
        setShowModalHistorico(true);
        setTabAtivaHistorico('aulas');

        try {
            const response = await Api.get(`/api/historico-aluno-modulo/${id}/${usuario.id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setHistoricoAluno(response.data);
        } catch (error) {
            console.error('Erro ao buscar histórico:', error);
            setToast({
                header: 'Erro!',
                body: error.response?.data?.message || 'Não foi possível carregar o histórico do aluno.',
                type: 'toast-error'
            });
            setShowToast(true);
            setHistoricoAluno(null);
        } finally {
            setLoadingHistorico(false);
        }
    }, [id, token, setToast, setShowToast]);

    // Função para verificar acesso às avaliações de reação
    const handleVerAvaliacaoReacao = useCallback(async (tipo, data) => {
        let shouldContinue = true;

        // Verificar se temos os dados completos do usuário
        if (!usuarioSelecionado.gestor_responsavel) {
            try {
                // Garantir que aguardamos a conclusão da busca
                await buscarDadosUsuario(usuarioSelecionado.id);
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
                shouldContinue = false;
            }
        }

        if (!shouldContinue) {
            setToast({
                header: 'Erro!',
                body: 'Não foi possível obter os dados do usuário para verificar permissões.',
                type: 'toast-error'
            });
            setShowToast(true);
            return;
        }

        // Verificar se o usuário tem permissão para ver a avaliação de reação
        const gestorResponsavelId = usuarioSelecionado.gestor_responsavel;
        const isGestorResponsavel = String(gestorResponsavelId) === String(idUsuarioLogado);
        const canViewReactionEvaluation = isAdminOrRH || (nivel === 'Gestor' && isGestorResponsavel);

        if ((tipo === 'Avaliação de Reação' || tipo === 'Avaliação de Reação Híbrida') && !canViewReactionEvaluation) {
            setToast({
                header: 'Acesso Negado',
                body: 'Apenas o gestor responsável, Administradores e RH podem ver avaliações de reação.',
                type: 'toast-warning'
            });
            setShowToast(true);
            return;
        }

        // Exibir o modal de visualização da avaliação
        setModalVerAvaliacaoReacao({
            show: true,
            tipo,
            data
        });
    }, [buscarDadosUsuario, idUsuarioLogado, isAdminOrRH, nivel, usuarioSelecionado, setToast, setModalVerAvaliacaoReacao]);

    // Função para exportar avaliação de reação para Excel
    const exportarAvaliacaoReacaoExcel = useCallback(() => {
        if (!modalVerAvaliacaoReacao.data) return;

        try {
            // Importar a biblioteca Excel
            const XLSX = require('xlsx');

            // Dados do aluno e módulo para a planilha
            const infoData = {
                "Aluno": usuarioSelecionado.nome_completo,
                "Código": usuarioSelecionado.codigo,
                "Unidade": usuarioSelecionado.unidade,
                "Curso": dataInfoCurso[0]?.nome || "Não disponível",
                "Módulo": modalVerAvaliacaoReacao.data.nomeModulo,
                "Tipo de Avaliação": modalVerAvaliacaoReacao.tipo,
                "Data Avaliação": modalVerAvaliacaoReacao.data.data_formatada
            };

            // Buscar dados do gestor responsável, se disponível
            let gestorData = {
                "Gestor Responsável": "Não disponível"
            };

            // Função para continuar a exportação após obter dados do gestor
            const continuarExportacao = (gestorData) => {
                // Preparar os dados das respostas
                let respostasData = [];

                try {
                    if (modalVerAvaliacaoReacao.tipo === 'Avaliação de Reação' || modalVerAvaliacaoReacao.tipo === 'Avaliação de Reação Híbrida') {
                        // Garantir que questoes e respostas estão em formato adequado
                        const questoes = typeof modalVerAvaliacaoReacao.data.questoes === 'string'
                            ? JSON.parse(modalVerAvaliacaoReacao.data.questoes)
                            : modalVerAvaliacaoReacao.data.questoes;

                        const respostas = typeof modalVerAvaliacaoReacao.data.respostas === 'string'
                            ? JSON.parse(modalVerAvaliacaoReacao.data.respostas)
                            : modalVerAvaliacaoReacao.data.respostas;

                        if (Array.isArray(questoes) && Array.isArray(respostas)) {
                            respostasData = questoes.map((questao, index) => ({
                                "Pergunta": questao,
                                "Resposta": respostas[index] || "Não respondida"
                            }));
                        }
                    } else {
                        // Renderização para avaliações normais
                        const respostasObj = typeof modalVerAvaliacaoReacao.data.respostas === 'string'
                            ? JSON.parse(modalVerAvaliacaoReacao.data.respostas)
                            : modalVerAvaliacaoReacao.data.respostas;

                        const questoesObj = typeof modalVerAvaliacaoReacao.data.questoes === 'string'
                            ? JSON.parse(modalVerAvaliacaoReacao.data.questoes)
                            : modalVerAvaliacaoReacao.data.questoes;

                        respostasData = Object.entries(respostasObj).map(([perguntaId, resposta]) => {
                            const questaoTexto = questoesObj[perguntaId]?.questao || `Pergunta ${Number(perguntaId) + 1}`;
                            return {
                                "Pergunta": questaoTexto,
                                "Resposta": resposta
                            };
                        });
                    }
                } catch (error) {
                    console.error('Erro ao processar dados para Excel:', error);
                    respostasData = [{
                        "Erro": "Não foi possível processar os dados das respostas",
                        "Detalhes": error.message
                    }];
                }

                // Criar uma nova planilha
                const workbook = XLSX.utils.book_new();

                // Adiciona planilha com dados do curso e aluno
                const worksheetInfo = XLSX.utils.json_to_sheet([infoData]);
                XLSX.utils.book_append_sheet(workbook, worksheetInfo, "Informações");

                // Adiciona planilha com dados do gestor
                const worksheetGestor = XLSX.utils.json_to_sheet([gestorData]);
                XLSX.utils.book_append_sheet(workbook, worksheetGestor, "Gestor");

                // Adiciona planilha de respostas
                const worksheetRespostas = XLSX.utils.json_to_sheet(respostasData);
                XLSX.utils.book_append_sheet(workbook, worksheetRespostas, "Respostas");

                // Adiciona comentários, se houver
                if (modalVerAvaliacaoReacao.data.comentarios) {
                    const comentariosData = [{
                        "Comentários": modalVerAvaliacaoReacao.data.comentarios
                    }];
                    const worksheetComentarios = XLSX.utils.json_to_sheet(comentariosData);
                    XLSX.utils.book_append_sheet(workbook, worksheetComentarios, "Comentários");
                }

                // Gera o arquivo e realiza o download
                const tipoAvaliacao = modalVerAvaliacaoReacao.tipo === 'Avaliação de Reação Híbrida' ? 'Reacao_Hibrida' : 'Reacao';
                const nomeArquivo = `Avaliacao_${tipoAvaliacao}_${usuarioSelecionado.nome_completo.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.xlsx`;
                XLSX.writeFile(workbook, nomeArquivo);

                setToast({
                    header: 'Sucesso!',
                    body: 'Relatório de avaliação de reação exportado com sucesso!',
                    type: 'toast-success'
                });
                setShowToast(true);
            };

            // Verificar se temos o gestor_responsavel do usuário
            if (usuarioSelecionado.gestor_responsavel) {
                Api.get(`/api/usuario/${usuarioSelecionado.gestor_responsavel}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }).then(response => {
                    if (response.data) {
                        gestorData = {
                            "Gestor Responsável": response.data.nome_completo || "Não disponível",
                            "Email do Gestor": response.data.email || "Não disponível",
                            "Unidade do Gestor": response.data.unidade || "Não disponível"
                        };
                    }
                    continuarExportacao(gestorData);
                }).catch(error => {
                    console.warn("Não foi possível obter dados do gestor:", error);
                    continuarExportacao(gestorData);
                });
            } else {
                continuarExportacao(gestorData);
            }
        } catch (error) {
            console.error("Erro ao exportar para Excel:", error);
            setToast({
                header: 'Erro!',
                body: 'Falha ao exportar. Verifique o console para mais detalhes.',
                type: 'toast-error'
            });
            setShowToast(true);
        }
    }, [modalVerAvaliacaoReacao, usuarioSelecionado, dataInfoCurso, setToast, token]);

    // Função auxiliar para verificar se todas as etapas estão concluídas exceto avaliação de reação
    const todasEtapasConcluidasExcetoReacao = useCallback((aluno) => {
        // Verificar aulas concluídas
        const aulasConcluidas = aluno.porcentagem_concluida === 100 ||
            aluno.progresso_etapas?.aulas?.concluido === true;

        // Verificar avaliação teórica concluída e aprovada
        const avaliacaoConcluida = aluno.progresso_etapas?.avaliacao?.concluido === true &&
            aluno.status !== 'Reprovado';

        // Verificar prática (apenas para cursos mistos)
        const praticaOk = dataInfoCurso[0]?.tipo !== 'misto' ||
            aluno.progresso_etapas?.pratica?.concluido === true ||
            praticasRegistradas[aluno.id]?.ativa;

        // Verificar se falta apenas avaliação de reação
        const faltaApenasReacao = !aluno.avaliacao_reacao_respondida;

        return aulasConcluidas && avaliacaoConcluida && praticaOk && faltaApenasReacao;
    }, [dataInfoCurso, praticasRegistradas]);

    const columns = useMemo(
        () => [
            {
                Header: () => null,
                id: 'foto',
                disableSortBy: true,
                Cell: () => (
                    <div className="d-flex align-items-center">
                        <div className="picture text-white bg-grey" style={{ fontSize: '22px', height: '42px', marginRight: '0px', width: '42px' }}>
                            <i className="bi bi-person" />
                        </div>
                    </div>
                )
            },
            {
                Header: () => null,
                accessor: 'nome_completo',
                disableSortBy: false,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <>
                        <div className=''>{value}</div>
                        <div className='d-flex align-items-center gap-2'>
                            <div className='badge bg-primary'>{original.codigo}</div>
                            <Tippy content={original.email}>
                                <i className="bi bi-envelope-fill text-primary cursor-pointer"></i>
                            </Tippy>
                        </div>
                    </>
                )
            },
            {
                Header: () => null,
                accessor: 'status',
                disableSortBy: false,
                Cell: ({ cell: { value }, row: { original } }) => {
                    const etapaAtual = original.etapa_atual || value;
                    const pendenciaDetalhada = original.pendencia_detalhada || {};

                    // Determinar cor do badge baseado na etapa
                    let badgeColor = 'primary';
                    if (value === 'Aprovado') {
                        badgeColor = 'success';
                    } else if (value === 'Em progresso') {
                        badgeColor = 'warning';
                    } else if (value === 'Pendente') {
                        badgeColor = 'dark';
                    }

                    // Texto do tooltip com detalhes
                    const tooltipContent = pendenciaDetalhada.descricao
                        ? `${etapaAtual}: ${pendenciaDetalhada.descricao}`
                        : etapaAtual;

                    return (
                        <div className="text-center">
                            <Tippy content={tooltipContent}>
                                <div className={`badge bg-${badgeColor} cursor-pointer badge-text-white-force`}>
                                    {etapaAtual}
                                </div>
                            </Tippy>
                        </div>
                    );
                }
            },
            {
                Header: () => null,
                accessor: 'email',
                visible: false,
                disableSortBy: true
            },
            {
                Header: () => null,
                accessor: 'porcentagem_concluida',
                disableSortBy: true,
                Cell: ({ cell: { value }, row: { original } }) => {
                    let texto = '';
                    let color = 'primary';
                    let width = 0;
                    let textColor = 'text-white';

                    if (parseInt(value) === 100) {
                        texto = 'Concluído';
                        color = 'success';
                        width = 100;
                    } else {
                        texto = `${value}%`;
                        width = value;
                    }

                    return (
                        <div className="progress">
                            <div
                                className={`progress-bar progress-bar-striped progress-bar-animated bg-${color} ${textColor} progress-text-white-force`}
                                style={{ width: width + '%', color: '#fff', '--bs-progress-bar-color': '#fff' }}
                            >
                                {texto}
                            </div>
                        </div>
                    )
                }
            },
            {
                Header: () => null,
                id: 'pratica',
                disableSortBy: true,
                Cell: ({ row: { original } }) => (
                    dataInfoCurso[0].tipo === 'misto' && (
                        <div className="text-center">
                            <Tippy content={
                                praticasRegistradas[original.id]?.ativa
                                    ? "Visualizar Prática"
                                    : praticasRegistradas[original.id]?.arquivada
                                        ? "Visualizar Prática Arquivada"
                                        : nivel !== "Administrador"
                                            ? "Sem permissão"
                                            : "Registrar Prática"
                            }>
                                <button
                                    onClick={() => {
                                        if (nivel !== "Administrador" && !praticasRegistradas[original.id]) return;
                                        setUsuarioSelecionado(original);
                                        verificarPraticaExistente(id, original.id);
                                    }}
                                    className={`btn btn-outline-${praticasRegistradas[original.id]?.ativa
                                        ? 'success'
                                        : praticasRegistradas[original.id]?.arquivada
                                            ? 'warning'
                                            : 'primary'
                                        } text-${praticasRegistradas[original.id]?.ativa
                                            ? 'success'
                                            : praticasRegistradas[original.id]?.arquivada
                                                ? 'warning'
                                                : 'primary'
                                        } rounded px-2 ${nivel !== "Administrador" && !praticasRegistradas[original.id] ? 'opacity-50 cursor-not-allowed' : ''}`}
                                >
                                    <i className={`bi bi-${praticasRegistradas[original.id]?.ativa
                                        ? 'check-circle'
                                        : praticasRegistradas[original.id]?.arquivada
                                            ? 'archive'
                                            : 'person-workspace'
                                        }`}></i>
                                </button>
                            </Tippy>
                        </div>
                    )
                )
            },
            {
                Header: () => null,
                id: 'notas',
                accessor: row => row.id,
                disableSortBy: true,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="d-flex gap-2">
                        <Tippy content={original.tem_notas_disponiveis ? "Conferir notas" : "Notas não disponíveis"}>
                            <button
                                className={`btn btn-outline-primary justify-content-center align-items-center rounded px-2 ${!original.tem_notas_disponiveis ? 'cursor-not-allowed opacity-50' : ''}`}
                                onClick={() => {
                                    if (!original.tem_notas_disponiveis) return;
                                    handleVerNotas({ id: original.id, nome_completo: original.nome_completo });
                                }}>
                                <i className="bi bi-file-text" />
                            </button>
                        </Tippy>
                        <Tippy content="Ver histórico completo">
                            <button
                                className="btn btn-outline-primary justify-content-center align-items-center rounded px-2"
                                onClick={() => {
                                    handleVerHistorico({ id: original.id, nome_completo: original.nome_completo });
                                }}>
                                <i className="bi bi-clock-history" />
                            </button>
                        </Tippy>
                        {nivel === "Administrador" && (
                            <Tippy content="Reiniciar curso forçado">
                                <button
                                    className="btn btn-outline-danger justify-content-center align-items-center rounded px-2"
                                    onClick={() => {
                                        setUsuarioSelecionado(original);
                                        setCursoReiniciarForcado({ id: id, nome: dataInfoCurso[0]?.nome || 'Curso' });
                                        setShowModalReiniciarForcado(true);
                                    }}>
                                    <i className="bi bi-arrow-clockwise" />
                                </button>
                            </Tippy>
                        )}
                    </div>
                )
            },
            {
                Header: () => null,
                id: 'certificado',
                accessor: row => row.id,
                disableSortBy: true,
                Cell: ({ cell: { value }, row: { original } }) => {
                    // Verificar se pode habilitar sem avaliação de reação (apenas para admin)
                    const podeHabilitarSemReacao = nivel === "Administrador" &&
                        todasEtapasConcluidasExcetoReacao(original);

                    // Lógica atual (todas as etapas + reação)
                    const podeHabilitarCompleto = original.status === 'Aprovado' &&
                        original.avaliacao_reacao_respondida &&
                        (dataInfoCurso[0].tipo !== 'misto' ||
                            (praticasRegistradas[original.id]?.ativa || praticasRegistradas[original.id]?.arquivada)) &&
                        nivel === "Administrador";

                    const isDisabled = !(podeHabilitarCompleto || podeHabilitarSemReacao);

                    return (
                        <div className='d-flex align-items-center justify-content-center'>
                            <div className="form-check form-switch">
                                <Tippy content={
                                    podeHabilitarSemReacao
                                        ? "Permitir certificado (falta apenas avaliação de reação)"
                                        : original.status !== 'Aprovado'
                                            ? "Usuário precisa estar aprovado"
                                            : !original.avaliacao_reacao_respondida
                                                ? "Usuário precisa responder a avaliação de reação"
                                                : dataInfoCurso[0].tipo === 'misto' && !praticasRegistradas[original.id]
                                                    ? "Usuário precisa concluir a prática"
                                                    : nivel !== "Administrador"
                                                        ? "Apenas administradores podem alterar"
                                                        : "Permitir certificado"
                                }>
                                    {isDisabled ? (
                                        <div className="cursor-not-allowed text-muted" style={{ marginLeft: "-2em" }}>
                                            <i className="bi bi-lock-fill fs-5"></i>
                                        </div>
                                    ) : (
                                        <input
                                            className="form-check-input cursor-pointer"
                                            type="checkbox"
                                            role="switch"
                                            checked={checkedStates[original.id] || false}
                                            onChange={() => handleSwitchChange(original.id, !checkedStates[original.id])}
                                        />
                                    )}
                                </Tippy>
                            </div>
                        </div>
                    )
                }
            },
            {
                Header: 'Codigo',
                accessor: 'codigo',
                visible: false  // Esta coluna será filtrada, mas não exibida
            }
        ],
        [checkedStates, handleSwitchChange, nivel, dataInfoCurso, praticasRegistradas, id, verificarPraticaExistente, handleVerNotas, handleVerHistorico, todasEtapasConcluidasExcetoReacao]
    );

    const LoadingScreen = () => {
        return (
            <div className="d-flex align-items-center justify-content-center p-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Carregando...</span>
                </div>
            </div>
        )
    }

    // Componente de visualização mobile com filtros e paginação
    // Componente de visualização mobile com paginação
    const MobileAlunosView = ({ alunos, pageSize: externalPageSize = DEFAULT_PAGE_SIZE, AlunoMobileCard }) => {
        const [pageIndex, setPageIndex] = useState(0);
        const [pageSize, setPageSize] = useState(externalPageSize);

        useEffect(() => {
            setPageSize(externalPageSize);
        }, [externalPageSize]);

        // Paginação
        const totalPages = Math.ceil(alunos.length / pageSize);
        const startIndex = pageIndex * pageSize;
        const endIndex = startIndex + pageSize;
        const paginatedAlunos = alunos.slice(startIndex, endIndex);

        const canPreviousPage = pageIndex > 0;
        const canNextPage = pageIndex < totalPages - 1;

        return (
            <>
                <div className="mb-3">
                    {paginatedAlunos.length > 0 ? (
                        <div className="row">
                            {paginatedAlunos.map((aluno) => (
                                <AlunoMobileCard key={aluno.id} aluno={aluno} />
                            ))}
                        </div>
                    ) : (
                        <p className="text-center text-muted mb-0 py-4">Nenhum aluno encontrado</p>
                    )}
                </div>

                {/* Paginação */}
                {totalPages > 1 && (
                    <div className="card border-0 shadow-sm rounded-4 p-3">
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                            <span className="text-muted">
                                Exibindo {Math.min(startIndex + 1, alunos.length)} - {Math.min(endIndex, alunos.length)} de {alunos.length} registros
                            </span>
                            <div className="d-flex align-items-center gap-2">
                                <span className="text-muted">Página {pageIndex + 1} de {totalPages}</span>
                                <button
                                    className="btn btn-primary btn-sm text-white"
                                    onClick={() => setPageIndex(pageIndex - 1)}
                                    disabled={!canPreviousPage}
                                >
                                    <i className="bi bi-caret-left"></i>
                                </button>
                                <button
                                    className="btn btn-primary btn-sm text-white"
                                    onClick={() => setPageIndex(pageIndex + 1)}
                                    disabled={!canNextPage}
                                >
                                    <i className="bi bi-caret-right"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    };

    // Componente de card mobile para alunos
    const AlunoMobileCard = ({ aluno }) => {
        const etapaAtual = aluno.etapa_atual || aluno.status;

        // Determinar cor do badge baseado na etapa
        let badgeColor = 'primary';
        if (aluno.status === 'Aprovado') {
            badgeColor = 'success';
        } else if (aluno.status === 'Em progresso') {
            badgeColor = 'warning';
        } else if (aluno.status === 'Pendente') {
            badgeColor = 'dark';
        }

        // Progresso
        let progressoTexto = '';
        let progressoColor = 'primary';
        let progressoWidth = 0;

        if (parseInt(aluno.porcentagem_concluida) === 100) {
            progressoTexto = 'Concluído';
            progressoColor = 'success';
            progressoWidth = 100;
        } else {
            progressoTexto = `${aluno.porcentagem_concluida}%`;
            progressoWidth = aluno.porcentagem_concluida;
        }

        // Verificar se pode habilitar sem avaliação de reação (apenas para admin)
        const podeHabilitarSemReacaoMobile = nivel === "Administrador" &&
            todasEtapasConcluidasExcetoReacao(aluno);

        // Lógica atual (todas as etapas + reação)
        const podeHabilitarCompletoMobile = aluno.status === 'Aprovado' &&
            aluno.avaliacao_reacao_respondida &&
            (dataInfoCurso[0].tipo !== 'misto' ||
                (praticasRegistradas[aluno.id]?.ativa || praticasRegistradas[aluno.id]?.arquivada)) &&
            nivel === "Administrador";

        const isCertificadoDisabled = !(podeHabilitarCompletoMobile || podeHabilitarSemReacaoMobile);

        return (
            <div className="col-12 mb-2">
                <div className="card border-0 shadow-sm rounded-3">
                    <div className="card-body p-3">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                            <div className="flex-grow-1">
                                <h6 className="mb-1 fw-semibold">{aluno.nome_completo}</h6>
                                <div className="d-flex align-items-center gap-2 mb-2">
                                    <small className="text-muted">{aluno.codigo}</small>
                                    <span className={`badge bg-${badgeColor} badge-text-white-force`}>
                                        {etapaAtual}
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Progresso */}
                        <div className="mb-2">
                            <div className="progress" style={{ height: '6px' }}>
                                <div className={`progress-bar bg-${progressoColor}`} style={{ width: progressoWidth + '%' }}></div>
                            </div>
                            <small className="text-muted">{progressoTexto}</small>
                        </div>

                        {/* Ações */}
                        <div className="d-flex gap-1 pt-2 border-top">
                            {dataInfoCurso[0]?.tipo === 'misto' && (
                                <button
                                    onClick={() => {
                                        if (nivel !== "Administrador" && !praticasRegistradas[aluno.id]) return;
                                        setUsuarioSelecionado(aluno);
                                        verificarPraticaExistente(id, aluno.id);
                                    }}
                                    className={`btn btn-sm btn-outline-${praticasRegistradas[aluno.id]?.ativa
                                        ? 'success'
                                        : praticasRegistradas[aluno.id]?.arquivada
                                            ? 'warning'
                                            : 'primary'
                                        } ${nivel !== "Administrador" && !praticasRegistradas[aluno.id] ? 'opacity-50' : ''}`}
                                >
                                    <i className={`bi bi-${praticasRegistradas[aluno.id]?.ativa
                                        ? 'check-circle'
                                        : praticasRegistradas[aluno.id]?.arquivada
                                            ? 'archive'
                                            : 'person-workspace'
                                        }`}></i>
                                </button>
                            )}

                            <button
                                className={`btn btn-sm btn-outline-primary ${!aluno.tem_notas_disponiveis ? 'opacity-50' : ''}`}
                                onClick={() => {
                                    if (!aluno.tem_notas_disponiveis) return;
                                    handleVerNotas({ id: aluno.id, nome_completo: aluno.nome_completo });
                                }}
                            >
                                <i className="bi bi-file-text"></i>
                            </button>

                            <button
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => {
                                    handleVerHistorico({ id: aluno.id, nome_completo: aluno.nome_completo });
                                }}
                            >
                                <i className="bi bi-clock-history"></i>
                            </button>

                            <div className="ms-auto">
                                {isCertificadoDisabled ? (
                                    <i className="bi bi-lock text-muted"></i>
                                ) : (
                                    <div className="form-check form-switch">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            role="switch"
                                            checked={checkedStates[aluno.id] || false}
                                            onChange={() => handleSwitchChange(aluno.id, !checkedStates[aluno.id])}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const {
        register: registerEditarPratica,
        handleSubmit: handleSubmitEditarPratica,
        formState: { errors: errorsEditarPratica },
        control: controlEditarPratica,
        reset: resetEditarPratica
    } = useForm();

    const handleEditarPratica = () => {
        resetEditarPratica({
            data_treinamento: praticaAtual.data_treinamento,
            local_treinamento: praticaAtual.local_treinamento,
            gestor: praticaAtual.gestor
        });
        setShowModalVisualizarPratica(false);
        setShowModalEditarPratica(true);
    };

    const onSubmitEditarPratica = async (data) => {
        setLoadingEditar(true);
        const formData = new FormData();
        formData.append('data_treinamento', data.data_treinamento);
        formData.append('local_treinamento', data.local_treinamento);
        formData.append('gestor', data.gestor);

        if (data.lista_presenca instanceof FileList) {
            formData.append('lista_presenca', data.lista_presenca[0]);
        }

        if (data.fotos instanceof FileList) {
            for (let i = 0; i < data.fotos.length; i++) {
                formData.append(`fotos[${i}]`, data.fotos[i]);
            }
        }

        try {
            const response = await Api.post(`/api/editar-praticas/${praticaAtual.id}`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });

            // Se a edição foi bem-sucedida, atualizar a prática atual com os novos dados
            if (response.data.pratica) {
                setPraticaAtual({
                    ...praticaAtual,
                    ...response.data.pratica,
                    data_treinamento: data.data_treinamento,
                    local_treinamento: data.local_treinamento,
                    gestor: data.gestor
                });
            }

            setToast({ header: 'Sucesso!', body: response.data.message, type: 'toast-success' });
            // Fecha o modal de edição
            setShowModalEditarPratica(false);
            // Não reabre o modal de visualização
            setShowModalVisualizarPratica(false);
        } catch (error) {
            setToast({ header: 'Ops!', body: error.response?.data?.message || 'Erro ao editar prática', type: 'toast-error' });
        } finally {
            setLoadingEditar(false);
        }
        setShowToast(true);
    };

    const handleDeletarPratica = async () => {
        try {
            const response = await Api.delete(`/api/praticas/${praticaAtual.id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            // Atualizar o estado localmente em vez de fazer outra chamada API
            const updatedPraticasMap = { ...praticasRegistradas };
            delete updatedPraticasMap[usuarioSelecionado.id];
            setPraticasRegistradas(updatedPraticasMap);

            setToast({ header: 'Sucesso!', body: response.data.message, type: 'toast-success' });
            setShowModalConfirmacaoDeletar(false);
            setShouldReopenDetailsModal(false); // Não reabrir pois a prática foi deletada
        } catch (error) {
            setToast({ header: 'Ops!', body: error.response?.data?.message || 'Erro ao deletar prática', type: 'toast-error' });
        }
        setShowToast(true);
    };

    return (
        <>
            <Toast
                show={showToast}
                onClose={() => setShowToast(false)}
                delay={4000}
                autohide
                className={`position-fixed top-0 end-0 m-3 toast-icon ${toast.type || 'toast-error'}`}
                style={{ zIndex: 1060 }}
            >
                <Toast.Header>
                    <strong className="me-auto">{toast.header}</strong>
                </Toast.Header>
                <Toast.Body>{toast.body}</Toast.Body>
            </Toast>

            {/* Botão de Voltar Moderno */}
            <div className="d-flex justify-content-start align-items-center mb-4">
                <button 
                    onClick={() => navigate(-1)} 
                    className="btn btn-outline-primary rounded-pill px-4 py-1 d-flex align-items-center gap-2 shadow-sm"
                    style={{
                        transition: 'all 0.3s ease',
                        borderWidth: '2px',
                        fontWeight: '500'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateX(-5px)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(13, 110, 253, 0.3)';
                        e.currentTarget.style.backgroundColor = '#0d6efd';
                        e.currentTarget.style.color = 'white';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateX(0)';
                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                        e.currentTarget.style.backgroundColor = 'transparent';
                        e.currentTarget.style.color = '#0d6efd';
                    }}
                >
                    <i className="bi bi-arrow-left fs-5"></i>
                    <span>Voltar</span>
                </button>
            </div>

            {dataInfoCurso[0] &&
                <div className="fade-in w-100 mb-6 mb-md-0" style={{ marginBottom: '100px' }}>
                    <div className="rounded-3 mb-4">
                        <div className="mb-3 d-flex justify-content-between align-items-start">
                            <div>
                                <h1 className="text-primary fs-2 fw-bold mb-2">Análise geral dos alunos</h1>
                                <p className="text-muted mb-0">
                                    Lista de alunos disponíveis para o curso <span className='fw-bold'>{dataInfoCurso[0].nome}</span>
                                </p>
                            </div>
                            {dataInfoCurso[0]?.tipo === 'misto' && nivel === "Administrador" && (
                                <button
                                    className="btn btn-primary text-white"
                                    onClick={() => {
                                        setAlunosSelecionadosMassa([]);
                                        setShowModalPraticaMassa(true);
                                    }}
                                >
                                    <i className="bi bi-people-fill me-2"></i>
                                    Registrar Prática em Massa
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Barra de Filtros Compacta */}
                    <div className="card border-0 shadow-sm mb-3">
                        <div className="card-body p-3">
                            <div className="row g-2 align-items-end">
                                <div className="col-md-4">
                                    <label className="form-label text-primary fw-medium small mb-1">Buscar</label>
                                    <input
                                        type="search"
                                        className="form-control"
                                        placeholder="Pesquise pelo nome desejado..."
                                        value={globalFilter || ""}
                                        onChange={(e) => setGlobalFilter(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-primary fw-medium small mb-1">Tipo</label>
                                    <Select
                                        value={filterTipo.find(opt => opt.value === selectedTipo)}
                                        onChange={(selected) => setSelectedTipo(selected ? selected.value : DEFAULT_LISTA_TIPO)}
                                        options={filterTipo}
                                        styles={customStyles}
                                        placeholder="Tipo"
                                        isClearable={false}
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-primary fw-medium small mb-1">Status</label>
                                    <Select
                                        value={filterStatus.find(opt => opt.value === selectedStatus)}
                                        onChange={(selected) => setSelectedStatus(selected ? selected.value : 'todos')}
                                        options={filterStatus}
                                        styles={customStyles}
                                        placeholder="Status"
                                        isClearable={false}
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                    />
                                </div>
                                <div className="col-md-2">
                                    <button
                                        className="btn btn-outline-primary w-100 py-2"
                                        onClick={() => setShowDrawerFiltros(true)}
                                    >
                                        <i className="bi bi-funnel me-1"></i>
                                        Mais filtros
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Chips de Filtros Ativos */}
                    {(selectedFilter || selectedStatus !== 'todos' || selectedTipo !== DEFAULT_LISTA_TIPO) && (
                        <div className="mb-3 d-flex flex-wrap gap-2">
                            {selectedFilter && (
                                <Badge bg="primary" className="d-flex align-items-center gap-1" style={{ fontSize: '0.875rem', padding: '0.5rem 0.75rem' }}>
                                    Filtro: {filterSelect.find(f => f.value === selectedFilter)?.label}
                                    <button
                                        type="button"
                                        className="btn-close btn-close-white"
                                        style={{ fontSize: '0.6rem' }}
                                        onClick={() => setSelectedFilter(null)}
                                        aria-label="Remover filtro"
                                    ></button>
                                </Badge>
                            )}
                            {selectedStatus !== 'todos' && (
                                <Badge bg="primary" className="d-flex align-items-center gap-1" style={{ fontSize: '0.875rem', padding: '0.5rem 0.75rem' }}>
                                    Status: {filterStatus.find(f => f.value === selectedStatus)?.label}
                                    <button
                                        type="button"
                                        className="btn-close btn-close-white"
                                        style={{ fontSize: '0.6rem' }}
                                        onClick={() => setSelectedStatus('todos')}
                                        aria-label="Remover filtro"
                                    ></button>
                                </Badge>
                            )}
                            {selectedTipo !== DEFAULT_LISTA_TIPO && (
                                <Badge bg="primary" className="d-flex align-items-center gap-1" style={{ fontSize: '0.875rem', padding: '0.5rem 0.75rem' }}>
                                    Tipo: {filterTipo.find(f => f.value === selectedTipo)?.label}
                                    <button
                                        type="button"
                                        className="btn-close btn-close-white"
                                        style={{ fontSize: '0.6rem' }}
                                        onClick={() => setSelectedTipo(DEFAULT_LISTA_TIPO)}
                                        aria-label="Remover filtro"
                                    ></button>
                                </Badge>
                            )}
                        </div>
                    )}

                    {/* Drawer de Filtros Avançados */}
                    <Offcanvas show={showDrawerFiltros} onHide={() => setShowDrawerFiltros(false)} placement="end">
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Filtros Avançados</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body className="d-flex flex-column">
                            <div className="mb-3">
                                <label className="form-label text-primary fw-medium">Filtro de Progresso</label>
                                <Select
                                    value={selectedFilter ? filterSelect.find(opt => opt.value === selectedFilter) : null}
                                    onChange={(selected) => setSelectedFilter(selected ? selected.value : null)}
                                    options={filterSelect}
                                    styles={customStyles}
                                    placeholder="Todas"
                                    isClearable
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label text-primary fw-medium">Registros por página</label>
                                <select
                                    className="form-select"
                                    value={pageSize}
                                    onChange={(e) => setPageSize(Number(e.target.value))}
                                >
                                    {[...PAGE_SIZE_OPTIONS].map(size => (
                                        <option key={size} value={size}>{size}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="mt-auto pt-3 border-top">
                                <div className="d-flex gap-2">
                                    <button
                                        className="btn btn-outline-secondary flex-fill"
                                        onClick={() => {
                                            setSelectedFilter(null);
                                            setSelectedStatus('todos');
                                            setSelectedTipo(DEFAULT_LISTA_TIPO);
                                            setPageSize(DEFAULT_PAGE_SIZE);
                                        }}
                                    >
                                        Limpar filtros
                                    </button>
                                    <button
                                        className="btn btn-primary flex-fill"
                                        onClick={() => setShowDrawerFiltros(false)}
                                    >
                                        Aplicar filtros
                                    </button>
                                </div>
                            </div>
                        </Offcanvas.Body>
                    </Offcanvas>

                    <div className={loading ? "" : "d-none"}><LoadingScreen /></div>
                    <div className={loading ? "d-none" : ""}>
                        {/* Versão Desktop - Tabela */}
                        <div className="d-none d-md-block">
                            <Table
                                columns={columns}
                                data={filteredAlunosBySearch}
                                globalFilter={globalFilter}
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                titulo={dataInfoCurso[0].nome}
                            />
                        </div>

                        {/* Versão Mobile - Cards */}
                        <div className="d-md-none">
                            <MobileAlunosView
                                alunos={filteredAlunosBySearch}
                                pageSize={pageSize}
                                AlunoMobileCard={AlunoMobileCard}
                            />
                        </div>
                    </div>

                </div>
            }

            <Modal size="lg" show={showModalNota.show} onHide={() => { setShowModalNota({ show: false }); setShowModalNotasInd(true) }}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">Trocar Nota <span className='text-dark fs-5'>({usuarioSelecionado.nome_completo})</span></span>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmitNota(onSubmitNota)}>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="body">
                                    <div className="row">
                                        <div className='label text-start fs-6 py-2 px-3'>Qual a nota para <span className='fw-bold'>{showModalNota.nome}</span></div>
                                        <div className="col">
                                            <input type="number" {...registerNota('nota', { required: true })} className="form-control" placeholder="Digite a nota" />
                                            <input type="hidden" {...registerNota('idUsuario', { required: true })} />
                                        </div>
                                        <div className="col">
                                            <input type="submit" className="btn btn-primary text-white w-100" value="Trocar nota" />
                                        </div>
                                        {errorsNota.nota && <span className='text-danger fs-7'>Nota é obrigatório.</span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showModalNotasInd} onHide={() => { setShowModalNotasInd(false); setUsuarioSelecionado({}); setDataModulos([]); setModalError({ show: false, message: '' }); }}>
                <Modal.Header closeButton>
                    <div className="w-100">
                        <p className="fw-semibold fs-5 text-primary mb-1">{usuarioSelecionado.nome_completo}</p>
                        <p className="fw-semibold fs-6 text-dark text-uppercase mb-0">{dataInfoCurso[0] && dataInfoCurso[0].nome}</p>
                    </div>
                </Modal.Header>
                <Modal.Body className="bg-gray-100">
                    {modalError.show ? (
                        <div className="alert alert-danger mt-3">
                            <div className="d-flex align-items-center">
                                <i className="bi bi-exclamation-triangle-fill fs-4 me-2"></i>
                                <div>
                                    <h5 className="alert-heading">Acesso Negado</h5>
                                    <p className="mb-0">{modalError.message}</p>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <>
                            {/* Versão Desktop - Tabela */}
                            <div className="d-none d-md-block">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="body">
                                            <div className="table-full-width mt-3 mb-3">
                                                <div className="table-responsive">
                                                    <table className="table align-middle mt-1">
                                                        <thead>
                                                            <tr className='text-nowrap'>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted'>Curso/Módulo</th>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted text-center'>Tipo</th>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted text-center'>Nota</th>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted text-center'>Data</th>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted text-center'>Avaliação</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                dataModulos && dataModulos.map((value, index) => {
                                                                    const rowClass = index % 2 === 0 ? 'even-row' : 'odd-row';
                                                                    return (
                                                                        ((value.progresso_avaliacoes && value.progresso_avaliacoes.length > 0) || value.progresso_avaliacao_extras) &&
                                                                        <>
                                                                            {value.progresso_avaliacoes && value.progresso_avaliacoes.map((avaliacao, idx) => (
                                                                                <tr key={`pa-${value.id}-${idx}`}>
                                                                                    <td className={`${rowClass} fw-semibold`}>{value.nome}</td>
                                                                                    <td className={`${rowClass} text-center`}>{avaliacao.tipo}</td>
                                                                                    <td className={`${rowClass} text-center fw-bold ${avaliacao.tipo === 'Avaliação de Reação' || avaliacao.tipo === 'Avaliação de Reação Híbrida'
                                                                                        ? ''
                                                                                        : (avaliacao.nota < 6 ? 'text-primary' : 'text-dark')
                                                                                        }`}>
                                                                                        {avaliacao.tipo === 'Avaliação de Reação' || avaliacao.tipo === 'Avaliação de Reação Híbrida' ? '-' : (avaliacao.nota || 'N/A')}
                                                                                    </td>
                                                                                    <td className={`${rowClass} text-center`}>{avaliacao.data_formatada || 'N/A'}</td>
                                                                                    <td className={`${rowClass} text-center`}>
                                                                                        {avaliacao.tipo === 'Avaliação de Reação' || avaliacao.tipo === 'Avaliação de Reação Híbrida' ? (
                                                                                            <span className='text-primary cursor-pointer' onClick={() => {
                                                                                                handleVerAvaliacaoReacao(avaliacao.tipo, avaliacao);
                                                                                            }}>Ver Respostas</span>
                                                                                        ) : (
                                                                                            <span className='text-primary cursor-pointer' onClick={() => {
                                                                                                setShouldGeneratePDF({ show: true, id: value.id, nome: value.nome, tipo: avaliacao.tipo })
                                                                                            }}>Visualizar</span>
                                                                                        )}
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                            {
                                                                                value.progresso_avaliacao_extras && value.progresso_avaliacao_extras.map((value, index) => {
                                                                                    return (
                                                                                        <tr key={`pae-${index}`}>
                                                                                            <td className={rowClass}><div>{value.nomeAvaliacaoExtra}</div><span className='text-muted fw-bold fs-7'>{value.nomeModulo}</span></td>
                                                                                            <td className={`${rowClass} text-center fw-regular`}>{value.tipo}</td>
                                                                                            <td className={`${rowClass} text-wrap text-center fw-bold ${value.nota < 6 ? 'text-primary' : 'text-dark'}`}>{value.nota || 'N/A'}</td>
                                                                                            <td className={`${rowClass} text-center`}>{value.data_formatada || 'N/A'}</td>
                                                                                            <td className={`${rowClass} text-center`}>
                                                                                                <span className='text-primary cursor-pointer' onClick={() => { setShouldGeneratePDF({ show: true, id: value.idAvaliacao, nome: value.nomeAvaliacaoExtra, tipo: value.tipo }) }}>Visualizar</span>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                            }
                                                                            {/* Avaliação de Reação */}
                                                                            {value.avaliacao_reacao && (
                                                                                <tr key={`reacao-${value.id}`}>
                                                                                    <td className={rowClass}><div>Avaliação de Reação</div><span className='text-muted fw-bold fs-7'>{value.nome}</span></td>
                                                                                    <td className={`${rowClass} text-center fw-regular`}>Reação</td>
                                                                                    <td className={`${rowClass} text-wrap text-center fw-bold`}>-</td>
                                                                                    <td className={`${rowClass} text-center`}>{value.avaliacao_reacao.data_formatada || 'N/A'}</td>
                                                                                    <td className={`${rowClass} text-center`}>
                                                                                        <span className='text-primary cursor-pointer' onClick={() => {
                                                                                            handleVerAvaliacaoReacao('Avaliação de Reação', { ...value.avaliacao_reacao, nomeModulo: value.nome });
                                                                                        }}>Ver Respostas</span>
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                            {/* Avaliação de Reação Híbrida */}
                                                                            {value.avaliacao_reacao_hibrido && (
                                                                                <tr key={`reacao-hibrido-${value.id}`}>
                                                                                    <td className={rowClass}><div>Avaliação de Reação Híbrida</div><span className='text-muted fw-bold fs-7'>{value.nome}</span></td>
                                                                                    <td className={`${rowClass} text-center fw-regular`}>Reação Híbrida</td>
                                                                                    <td className={`${rowClass} text-wrap text-center fw-bold`}>-</td>
                                                                                    <td className={`${rowClass} text-center`}>{value.avaliacao_reacao_hibrido.data_formatada || 'N/A'}</td>
                                                                                    <td className={`${rowClass} text-center`}>
                                                                                        <span className='text-primary cursor-pointer' onClick={() => {
                                                                                            handleVerAvaliacaoReacao('Avaliação de Reação Híbrida', { ...value.avaliacao_reacao_hibrido, nomeModulo: value.nome });
                                                                                        }}>Ver Respostas</span>
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                            <tr>
                                                                                <td colSpan={5} style={{ padding: 1 }} className='bg-dark'></td>
                                                                            </tr>
                                                                        </>
                                                                    )
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Versão Mobile - Cards */}
                            <div className="d-md-none">
                                {dataModulos && dataModulos.length > 0 ? (
                                    <div className="row">
                                        {dataModulos.map((value, index) => {
                                            if (!((value.progresso_avaliacoes && value.progresso_avaliacoes.length > 0) || value.progresso_avaliacao_extras)) return null;

                                            return (
                                                <div key={value.id} className="col-12 mb-3">
                                                    {value.progresso_avaliacoes && value.progresso_avaliacoes.map((avaliacao, idx) => (
                                                        <div key={`pa-${value.id}-${idx}`} className="card border-0 shadow-sm rounded-3 mb-2">
                                                            <div className="card-body p-3">
                                                                <h6 className="fw-semibold text-primary mb-2">{value.nome}</h6>
                                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                                    <div>
                                                                        <small className="text-muted d-block">Tipo</small>
                                                                        <span className="badge bg-info">{avaliacao.tipo}</span>
                                                                    </div>
                                                                    <div className="text-end">
                                                                        <small className="text-muted d-block">Nota</small>
                                                                        <span className={`fw-bold ${avaliacao.tipo === 'Avaliação de Reação' || avaliacao.tipo === 'Avaliação de Reação Híbrida' ? '' : (avaliacao.nota < 6 ? 'text-primary' : 'text-dark')}`}>
                                                                            {avaliacao.tipo === 'Avaliação de Reação' || avaliacao.tipo === 'Avaliação de Reação Híbrida' ? '-' : (avaliacao.nota || 'N/A')}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="mb-2">
                                                                    <small className="text-muted d-block mb-1">Data</small>
                                                                    <span>{avaliacao.data_formatada || 'N/A'}</span>
                                                                </div>
                                                                <div className="pt-2 border-top">
                                                                    {avaliacao.tipo === 'Avaliação de Reação' || avaliacao.tipo === 'Avaliação de Reação Híbrida' ? (
                                                                        <button className="btn btn-sm btn-primary w-100" onClick={() => handleVerAvaliacaoReacao(avaliacao.tipo, avaliacao)}>
                                                                            Ver Respostas
                                                                        </button>
                                                                    ) : (
                                                                        <button className="btn btn-sm btn-primary w-100" onClick={() => setShouldGeneratePDF({ show: true, id: value.id, nome: value.nome, tipo: avaliacao.tipo })}>
                                                                            Visualizar
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    {value.progresso_avaliacao_extras && value.progresso_avaliacao_extras.map((avaliacaoExtra, idx) => (
                                                        <div key={`pae-${idx}`} className="card border-0 shadow-sm rounded-3 mb-2">
                                                            <div className="card-body p-3">
                                                                <h6 className="fw-semibold text-primary mb-1">{avaliacaoExtra.nomeAvaliacaoExtra}</h6>
                                                                <small className="text-muted d-block mb-2">{avaliacaoExtra.nomeModulo}</small>
                                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                                    <div>
                                                                        <small className="text-muted d-block">Tipo</small>
                                                                        <span className="badge bg-info">{avaliacaoExtra.tipo}</span>
                                                                    </div>
                                                                    <div className="text-end">
                                                                        <small className="text-muted d-block">Nota</small>
                                                                        <span className={`fw-bold ${avaliacaoExtra.nota < 6 ? 'text-primary' : 'text-dark'}`}>
                                                                            {avaliacaoExtra.nota || 'N/A'}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="mb-2">
                                                                    <small className="text-muted d-block mb-1">Data</small>
                                                                    <span>{avaliacaoExtra.data_formatada || 'N/A'}</span>
                                                                </div>
                                                                <div className="pt-2 border-top">
                                                                    <button className="btn btn-sm btn-primary w-100" onClick={() => setShouldGeneratePDF({ show: true, id: avaliacaoExtra.idAvaliacao, nome: avaliacaoExtra.nomeAvaliacaoExtra, tipo: avaliacaoExtra.tipo })}>
                                                                        Visualizar
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    {value.avaliacao_reacao && (
                                                        <div className="card border-0 shadow-sm rounded-3 mb-2">
                                                            <div className="card-body p-3">
                                                                <h6 className="fw-semibold text-primary mb-1">Avaliação de Reação</h6>
                                                                <small className="text-muted d-block mb-2">{value.nome}</small>
                                                                <div className="mb-2">
                                                                    <small className="text-muted d-block mb-1">Data</small>
                                                                    <span>{value.avaliacao_reacao.data_formatada || 'N/A'}</span>
                                                                </div>
                                                                <div className="pt-2 border-top">
                                                                    <button className="btn btn-sm btn-primary w-100" onClick={() => handleVerAvaliacaoReacao('Avaliação de Reação', { ...value.avaliacao_reacao, nomeModulo: value.nome })}>
                                                                        Ver Respostas
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {value.avaliacao_reacao_hibrido && (
                                                        <div className="card border-0 shadow-sm rounded-3 mb-2">
                                                            <div className="card-body p-3">
                                                                <h6 className="fw-semibold text-primary mb-1">Avaliação de Reação Híbrida</h6>
                                                                <small className="text-muted d-block mb-2">{value.nome}</small>
                                                                <div className="mb-2">
                                                                    <small className="text-muted d-block mb-1">Data</small>
                                                                    <span>{value.avaliacao_reacao_hibrido.data_formatada || 'N/A'}</span>
                                                                </div>
                                                                <div className="pt-2 border-top">
                                                                    <button className="btn btn-sm btn-primary w-100" onClick={() => handleVerAvaliacaoReacao('Avaliação de Reação Híbrida', { ...value.avaliacao_reacao_hibrido, nomeModulo: value.nome })}>
                                                                        Ver Respostas
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <p className="text-center text-muted py-4">Nenhuma avaliação encontrada</p>
                                )}
                            </div>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer className="justify-content-center"></Modal.Footer>
            </Modal>

            <Modal size="lg" show={showModalEnviarProva} onHide={() => setShowModalEnviarProva(false)}>
                <Modal.Header closeButton>
                    <div className='row'>
                        <span className="fw-medium fs-4 text-primary">Enviar prova para...</span>
                        <span>Lorem ipsum dolor sit amet. Qui reprehenderit esse quo similique laudantium ex modi </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <section className="w-100 mt-5">
                        <div className="d-flex flex-column">
                            <div className="row d-flex align-items-center justify-content-between">
                                <div className="col-md-8">
                                    <div className="inner-addon right-addon">
                                        <i className="d-flex bi bi-search" />
                                        <input
                                            type="search"
                                            placeholder="Pesquise o aluno desejado...."
                                            className="form-control py-2"
                                        />
                                    </div>
                                </div>
                                <div className="d-flex mt-2 mt-md-0 align-items-center justify-content-end col-md-4">
                                    <select className="form-select py-2">
                                        <option disabled>Ordenação</option>
                                        <option value="1">Curso</option>
                                        <option value="2">Módulos</option>
                                        <option value="3">Em andamento</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="body">
                                <div className="table-full-width mt-3 mb-3">
                                    <div className="table-responsive">
                                        <table className="table align-middle mt-1">
                                            <tbody>
                                                <tr className='text-nowrap border-white'>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <div className="picture text-white bg-grey" style={{ cursor: 'pointer', fontSize: '22px', height: '42px', marginRight: '0px', width: '42px' }}>
                                                                <i className="bi bi-person" />
                                                            </div>
                                                        </div></td>
                                                    <td>Lorem Ipsum</td>
                                                    <td className='text-center fw-bold'>(99) 99999-9999</td>
                                                    <td className='text-center'>email@email.com</td>
                                                    <td className='text-center fw-bold'>
                                                        <input className="form-check-input border-primary" type="checkbox" />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center mb-4">
                        <button type="submit" className="btn btn-primary text-white px-3 py-2">Enviar</button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showModalPratica} onHide={() => {
                setShowModalPratica(false);
                setListaPresencaSelected(false);
                setFotosSelected(false);
            }}>
                <form onSubmit={handleSubmitPratica(onSubmitPratica)}>
                    <Modal.Header closeButton className="bg-gradient-primary text-white">
                        <div className="d-flex align-items-center">
                            <i className="bi bi-plus-circle me-3 fs-4"></i>
                            <div>
                                <h4 className="mb-0 fw-bold">Registrar Prática</h4>
                                <small className="opacity-75">{usuarioSelecionado.nome_completo}</small>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body className="p-4">
                        <div className="row g-4">
                            {/* Informações Básicas */}
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-light">
                                        <h6 className="mb-0 text-primary fw-bold">
                                            <i className="bi bi-info-circle me-2"></i>
                                            Informações do Treinamento
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-calendar-event me-1 text-primary"></i>
                                                    Data do Treinamento Prático
                                                </label>
                                                <input
                                                    type="datetime-local"
                                                    className={`form-control form-control ${errorsPratica.data_treinamento ? 'is-invalid' : ''}`}
                                                    {...registerPratica('data_treinamento', {
                                                        required: true
                                                    })}
                                                />
                                                {errorsPratica.data_treinamento && <div className="invalid-feedback">Campo obrigatório</div>}
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-geo-alt me-1 text-primary"></i>
                                                    Local do Treinamento
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control ${errorsPratica.local_treinamento ? 'is-invalid' : ''}`}
                                                    {...registerPratica('local_treinamento', {
                                                        required: true
                                                    })}
                                                />
                                                {errorsPratica.local_treinamento && <div className="invalid-feedback">Campo obrigatório</div>}
                                            </div>
                                            <div className="col-12">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-person-badge me-1 text-primary"></i>
                                                    Instrutor Responsável
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control ${errorsPratica.gestor ? 'is-invalid' : ''}`}
                                                    {...registerPratica('gestor', {
                                                        required: true
                                                    })}
                                                />
                                                {errorsPratica.gestor && <div className="invalid-feedback">Campo obrigatório</div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Upload de Arquivos */}
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-light">
                                        <h6 className="mb-0 text-primary fw-bold">
                                            <i className="bi bi-cloud-upload me-2"></i>
                                            Arquivos do Treinamento
                                        </h6>
                                        <small className="text-muted">Selecione os arquivos necessários para o registro</small>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-4">
                                            {/* Lista de Presença */}
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-file-earmark-text me-1 text-success"></i>
                                                    Lista de Presença
                                                </label>
                                                <div className="upload-area">
                                                    <label
                                                        htmlFor="lista_presenca"
                                                        className={`upload-label ${listaPresencaSelected ? 'uploaded' : ''}`}
                                                    >
                                                        <div className="upload-content">
                                                            <i className={`bi ${listaPresencaSelected ? 'bi-check-circle-fill text-success' : 'bi-file-earmark-plus'} upload-icon`}></i>
                                                            <div className="upload-text">
                                                                <div className="fw-semibold">
                                                                    {listaPresencaSelected ? 'Arquivo Selecionado' : 'Selecionar Lista de Presença'}
                                                                </div>
                                                                <small className="text-muted">PDF ou Imagem</small>
                                                            </div>
                                                        </div>
                                                        {listaPresencaSelected && (
                                                            <div className="upload-badge">
                                                                <span className="badge bg-success">
                                                                    <i className="bi bi-check me-1"></i>
                                                                    1 arquivo
                                                                </span>
                                                            </div>
                                                        )}
                                                    </label>
                                                    <Controller
                                                        control={controlPratica}
                                                        name="lista_presenca"
                                                        rules={{
                                                            required: true
                                                        }}
                                                        render={({ field: { onChange, onBlur, ref } }) => (
                                                            <input
                                                                id="lista_presenca"
                                                                type="file"
                                                                style={{ display: 'none' }}
                                                                accept=".pdf,image/*"
                                                                onBlur={onBlur}
                                                                ref={ref}
                                                                onChange={(e) => {
                                                                    const files = e.target.files;
                                                                    onChange(files);
                                                                    setListaPresencaSelected(files && files.length > 0);
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                                {errorsPratica.lista_presenca && <div className="invalid-feedback d-block">Campo obrigatório</div>}
                                            </div>

                                            {/* Fotos */}
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-images me-1 text-info"></i>
                                                    Fotos do Treinamento
                                                </label>
                                                <div className="upload-area">
                                                    <label
                                                        htmlFor="fotos"
                                                        className={`upload-label ${fotosSelected ? 'uploaded' : ''}`}
                                                    >
                                                        <div className="upload-content">
                                                            <i className={`bi ${fotosSelected ? 'bi-check-circle-fill text-success' : 'bi-images'} upload-icon`}></i>
                                                            <div className="upload-text">
                                                                <div className="fw-semibold">
                                                                    {fotosSelected ? 'Fotos Selecionadas' : 'Selecionar Fotos'}
                                                                </div>
                                                                <small className="text-muted">Múltiplas imagens</small>
                                                            </div>
                                                        </div>
                                                        {fotosSelected && (
                                                            <div className="upload-badge">
                                                                <span className="badge bg-success">
                                                                    <i className="bi bi-check me-1"></i>
                                                                    Arquivos selecionados
                                                                </span>
                                                            </div>
                                                        )}
                                                    </label>
                                                    <Controller
                                                        control={controlPratica}
                                                        name="fotos"
                                                        rules={{
                                                            required: true
                                                        }}
                                                        render={({ field: { onChange, onBlur, value, ref } }) => (
                                                            <input
                                                                id="fotos"
                                                                type="file"
                                                                style={{ display: 'none' }}
                                                                multiple
                                                                accept="image/*"
                                                                onBlur={onBlur}
                                                                ref={ref}
                                                                onChange={(e) => {
                                                                    const files = e.target.files;
                                                                    onChange(files);
                                                                    setFotosSelected(files && files.length > 0);
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                                {errorsPratica.fotos && <div className="invalid-feedback d-block">Campo obrigatório</div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="bg-light border-0 p-4">
                        <div className="d-flex gap-3 w-100">
                            <button
                                type="button"
                                className="btn btn-outline-secondary btn px-2"
                                onClick={() => {
                                    setShowModalPratica(false);
                                    setListaPresencaSelected(false);
                                    setFotosSelected(false);
                                }}
                            >
                                <i className="bi bi-x-circle me-2"></i>
                                Cancelar
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary btn px-2 ms-auto"
                                disabled={loadingRegistrar}
                            >
                                {loadingRegistrar ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Processando...
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-check-circle me-2"></i>
                                        Registrar Prática
                                    </>
                                )}
                            </button>
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal size="xl" show={showModalVisualizarPratica} onHide={() => setShowModalVisualizarPratica(false)}>
                <Modal.Header closeButton>
                    <Modal.Title className="text-center w-100">
                        <span className="d-block fs-6">
                            {praticaAtual && praticaAtual.arquivada
                                ? 'Prática Arquivada'
                                : 'Detalhes da Prática'
                            }
                        </span>
                        <small className="text-muted">
                            {praticaAtual && praticaAtual.arquivada
                                ? 'Esta prática foi arquivada'
                                : 'Visualização completa dos dados'
                            }
                        </small>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4 bg-gray-100">
                    {praticaAtual && (
                        <div className="row g-4">
                            {/* Informações do Aluno e Curso */}
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-primary">
                                        <h6 className="mb-0 text-white fw-bold">
                                            <i className="bi bi-person-circle me-2"></i>
                                            Informações do Aluno
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <div className="info-item">
                                                    <label className="info-label">
                                                        <i className="bi bi-person me-1 text-primary"></i>
                                                        Aluno
                                                    </label>
                                                    <p className="info-value">{praticaAtual.nome_usuario}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="info-item">
                                                    <label className="info-label">
                                                        <i className="bi bi-book me-1 text-primary"></i>
                                                        Curso
                                                    </label>
                                                    <p className="info-value">{praticaAtual.nome_curso}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Detalhes do Treinamento */}
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-primary">
                                        <h6 className="mb-0 text-white fw-bold">
                                            <i className="bi bi-calendar-event me-2"></i>
                                            Detalhes do Treinamento
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-3">
                                            <div className="col-md-4">
                                                <div className="info-item">
                                                    <label className="info-label">
                                                        <i className="bi bi-calendar3 me-1 text-success"></i>
                                                        Data do Treinamento
                                                    </label>
                                                    <p className="info-value">
                                                        {new Date(praticaAtual.data_treinamento).toLocaleDateString('pt-BR', {
                                                            day: '2-digit',
                                                            month: '2-digit',
                                                            year: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit'
                                                        })}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="info-item">
                                                    <label className="info-label">
                                                        <i className="bi bi-geo-alt me-1 text-info"></i>
                                                        Local do Treinamento
                                                    </label>
                                                    <p className="info-value">{praticaAtual.local_treinamento}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="info-item">
                                                    <label className="info-label">
                                                        <i className="bi bi-person-badge me-1 text-warning"></i>
                                                        Instrutor Responsável
                                                    </label>
                                                    <p className="info-value">{praticaAtual.gestor}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Arquivos */}
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-primary">
                                        <h6 className="mb-0 text-white fw-bold">
                                            <i className="bi bi-files me-2"></i>
                                            Arquivos do Treinamento
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-4">
                                            {/* Lista de Presença */}
                                            <div className="col-md-6">
                                                <div className="file-section">
                                                    <label className="file-section-label">
                                                        <i className="bi bi-file-earmark-text me-2 text-success"></i>
                                                        Lista de Presença
                                                    </label>
                                                    <div className="file-preview">
                                                        <a
                                                            href={`${process.env.REACT_APP_API_URL}/listapresenca/${praticaAtual.lista_presenca}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-outline-success btn w-100"
                                                        >
                                                            <i className="bi bi-eye me-2"></i>
                                                            Visualizar Lista de Presença
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Fotos */}
                                            {praticaAtual.fotos && praticaAtual.fotos.length > 0 && (
                                                <div className="col-md-6">
                                                    <div className="file-section">
                                                        <label className="file-section-label">
                                                            <i className="bi bi-images me-2 text-info"></i>
                                                            Fotos do Treinamento
                                                            <span className="badge bg-info ms-2">{praticaAtual.fotos.length}</span>
                                                        </label>
                                                        <div className="photos-grid">
                                                            {praticaAtual.fotos.map((foto, index) => (
                                                                <div key={index} className="photo-item">
                                                                    <a
                                                                        href={`${process.env.REACT_APP_API_URL}/imagens/${foto.nome_arquivo}`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className="photo-link"
                                                                    >
                                                                        <img
                                                                            src={`${process.env.REACT_APP_API_URL}/imagens/${foto.nome_arquivo}`}
                                                                            alt={`Foto ${index + 1}`}
                                                                            className="photo-img"
                                                                        />
                                                                        <div className="photo-overlay">
                                                                            <i className="bi bi-zoom-in"></i>
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Alerta de Prática Arquivada */}
                            {praticaAtual.arquivada && (
                                <div className="col-12">
                                    <div className="alert alert-warning border-0 shadow-sm">
                                        <div className="d-flex align-items-center">
                                            <i className="bi bi-exclamation-triangle-fill fs-4 me-3"></i>
                                            <div>
                                                <h6 className="alert-heading mb-1">Prática Arquivada</h6>
                                                <p className="mb-0">Esta prática foi arquivada porque o curso foi reiniciado. Você pode registrar uma nova prática para este curso.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    {praticaAtual && praticaAtual.arquivada ? (
                        <button
                            className="btn btn-primary text-white"
                            onClick={() => {
                                setShowModalVisualizarPratica(false);
                                setShowModalPratica(true);
                            }}
                        >
                            <i className="bi bi-plus-circle me-2"></i>
                            Registrar Nova Prática
                        </button>
                    ) : (
                        <>
                            <button
                                className="btn btn-outline-danger me-2"
                                onClick={() => {
                                    setShowModalVisualizarPratica(false);
                                    setShouldReopenDetailsModal(true);
                                    setShowModalConfirmacaoDeletar(true);
                                }}
                            >
                                <i className="bi bi-trash me-2"></i>
                                Excluir
                            </button>
                            <button
                                className="btn btn-primary text-white"
                                onClick={handleEditarPratica}
                            >
                                <i className="bi bi-pencil me-2"></i>
                                Editar
                            </button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>

            <Modal show={showModalConfirmacao} onHide={() => setShowModalConfirmacao(false)} size="lg" dialogClassName="modal-90w">
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-5 text-primary">Confirmação</span>
                </Modal.Header>
                <Modal.Body className="bg-gray-100 p-4">
                    <p>Você tem certeza que deseja {novoStatusCertificado ? 'liberar' : 'bloquear'} o certificado para este aluno?</p>
                    <p className="text-muted">Esta ação {novoStatusCertificado ? 'permitirá' : 'impedirá'} que o aluno tenha acesso ao certificado do curso.</p>
                </Modal.Body>
                <Modal.Footer className="justify-content-end">
                    <div className="d-flex justify-content-end">
                        <button
                            type="button"
                            className="btn me-2"
                            onClick={() => setShowModalConfirmacao(false)}
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={confirmarMudancaCertificado}
                        >
                            Confirmar
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            {/* Modal de Reinicialização Forçada */}
            <Modal show={showModalReiniciarForcado} onHide={() => {
                setShowModalReiniciarForcado(false);
                resetReiniciarForcado();
                setCursoReiniciarForcado(null);
            }} size="lg" backdrop="static">
                <form onSubmit={handleSubmitReiniciarForcado(onSubmitReiniciarForcado)}>
                    <Modal.Header closeButton>
                        <span className="fw-semibold fs-5 text-danger">
                            <i className="bi bi-exclamation-triangle-fill me-2"></i>
                            Reiniciar Curso Forçado
                        </span>
                    </Modal.Header>
                    <Modal.Body className="bg-gray-100 p-4">
                        <div className="alert alert-warning">
                            <i className="bi bi-exclamation-triangle me-2"></i>
                            <strong>Atenção!</strong> Esta ação irá reiniciar completamente o curso para o aluno, arquivando todo o progresso, certificados e tentativas. O certificado atual continua válido até a data de vencimento dele.
                        </div>

                        <div className="mb-3">
                            <label className="form-label fw-semibold">
                                Aluno: <span className="text-primary">{usuarioSelecionado.nome_completo}</span>
                            </label>
                        </div>

                        {cursoReiniciarForcado && (
                            <div className="mb-3">
                                <label className="form-label fw-semibold">
                                    Curso: <span className="text-primary">{cursoReiniciarForcado.nome}</span>
                                </label>
                            </div>
                        )}

                        <div className="mb-3">
                            <label htmlFor="justificativa" className="form-label fw-semibold">
                                Justificativa <span className="text-danger">*</span>
                            </label>
                            <textarea
                                id="justificativa"
                                className={`form-control ${errorsReiniciarForcado.justificativa ? 'is-invalid' : ''}`}
                                rows="5"
                                placeholder="Descreva o motivo da reinicialização forçada do curso (mínimo 10 caracteres)..."
                                {...registerReiniciarForcado('justificativa', {
                                    required: 'Justificativa é obrigatória',
                                    minLength: {
                                        value: 10,
                                        message: 'Justificativa deve ter no mínimo 10 caracteres'
                                    }
                                })}
                            />
                            {errorsReiniciarForcado.justificativa && (
                                <div className="invalid-feedback">
                                    {errorsReiniciarForcado.justificativa.message}
                                </div>
                            )}
                            <small className="form-text text-muted">
                                Mínimo de 10 caracteres. Esta justificativa será registrada e o aluno será notificado.
                            </small>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-end">
                        <div className="d-flex justify-content-end">
                            <button
                                type="button"
                                className="btn me-2"
                                onClick={() => {
                                    setShowModalReiniciarForcado(false);
                                    resetReiniciarForcado();
                                    setCursoReiniciarForcado(null);
                                }}
                                disabled={loadingReiniciarForcado}
                            >
                                Cancelar
                            </button>
                            <button
                                type="submit"
                                className="btn btn-danger"
                                disabled={loadingReiniciarForcado}
                            >
                                {loadingReiniciarForcado ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Reiniciando...
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-arrow-clockwise me-2"></i>
                                        Confirmar Reinicialização
                                    </>
                                )}
                            </button>
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal size="xl" show={showModalEditarPratica} onHide={() => {
                setShowModalEditarPratica(false);
                setListaPresencaEditSelected(false);
                setFotosEditSelected(false);
                setArquivosSelecionados({ listaPresenca: null, fotos: [] });
            }}>
                <form onSubmit={handleSubmitEditarPratica(onSubmitEditarPratica)}>
                    <Modal.Header closeButton className="bg-gradient-primary text-white">
                        <div className="d-flex align-items-center">
                            <i className="bi bi-pencil-square me-3 fs-4"></i>
                            <div>
                                <h4 className="mb-0 fw-bold">Editar Prática</h4>
                                <small className="opacity-75">{usuarioSelecionado.nome_completo}</small>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body className="p-4">
                        <div className="row g-4">
                            {/* Informações Básicas */}
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-light">
                                        <h6 className="mb-0 text-primary fw-bold">
                                            <i className="bi bi-info-circle me-2"></i>
                                            Informações do Treinamento
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-calendar-event me-1 text-primary"></i>
                                                    Data do Treinamento Prático
                                                </label>
                                                <input
                                                    type="datetime-local"
                                                    className={`form-control form-control ${errorsEditarPratica.data_treinamento ? 'is-invalid' : ''}`}
                                                    {...registerEditarPratica('data_treinamento', {
                                                        required: true
                                                    })}
                                                />
                                                {errorsEditarPratica.data_treinamento && <div className="invalid-feedback">Campo obrigatório</div>}
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-geo-alt me-1 text-primary"></i>
                                                    Local do Treinamento
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control ${errorsEditarPratica.local_treinamento ? 'is-invalid' : ''}`}
                                                    {...registerEditarPratica('local_treinamento', {
                                                        required: true
                                                    })}
                                                />
                                                {errorsEditarPratica.local_treinamento && <div className="invalid-feedback">Campo obrigatório</div>}
                                            </div>
                                            <div className="col-12">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-person-badge me-1 text-primary"></i>
                                                    Instrutor Responsável
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control ${errorsEditarPratica.gestor ? 'is-invalid' : ''}`}
                                                    {...registerEditarPratica('gestor', {
                                                        required: true
                                                    })}
                                                />
                                                {errorsEditarPratica.gestor && <div className="invalid-feedback">Campo obrigatório</div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Upload de Arquivos */}
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-light">
                                        <h6 className="mb-0 text-primary fw-bold">
                                            <i className="bi bi-cloud-upload me-2"></i>
                                            Arquivos do Treinamento
                                        </h6>
                                        <small className="text-muted">Selecione novos arquivos para substituir os existentes</small>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-4">
                                            {/* Lista de Presença */}
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-file-earmark-text me-1 text-success"></i>
                                                    Lista de Presença
                                                </label>
                                                <div className="upload-area">
                                                    <label
                                                        htmlFor="lista_presenca_edit"
                                                        className={`upload-label ${listaPresencaEditSelected ? 'uploaded' : ''}`}
                                                    >
                                                        <div className="upload-content">
                                                            <i className={`bi ${listaPresencaEditSelected ? 'bi-check-circle-fill text-success' : 'bi-file-earmark-plus'} upload-icon`}></i>
                                                            <div className="upload-text">
                                                                <div className="fw-semibold">
                                                                    {listaPresencaEditSelected ? 'Arquivo Selecionado' : 'Selecionar Lista de Presença'}
                                                                </div>
                                                                <small className="text-muted">
                                                                    {listaPresencaEditSelected ? arquivosSelecionados.listaPresenca?.name : 'PDF ou Imagem'}
                                                                </small>
                                                            </div>
                                                        </div>
                                                        {listaPresencaEditSelected && (
                                                            <div className="upload-badge">
                                                                <span className="badge bg-success">
                                                                    <i className="bi bi-check me-1"></i>
                                                                    1 arquivo
                                                                </span>
                                                            </div>
                                                        )}
                                                    </label>
                                                    <Controller
                                                        control={controlEditarPratica}
                                                        name="lista_presenca"
                                                        render={({ field: { onChange, onBlur, ref } }) => (
                                                            <input
                                                                id="lista_presenca_edit"
                                                                type="file"
                                                                style={{ display: 'none' }}
                                                                accept=".pdf,image/*"
                                                                onBlur={onBlur}
                                                                ref={ref}
                                                                onChange={(e) => {
                                                                    const files = e.target.files;
                                                                    onChange(files);
                                                                    setListaPresencaEditSelected(files && files.length > 0);
                                                                    setArquivosSelecionados(prev => ({
                                                                        ...prev,
                                                                        listaPresenca: files && files.length > 0 ? files[0] : null
                                                                    }));
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </div>

                                            {/* Fotos */}
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-images me-1 text-info"></i>
                                                    Fotos do Treinamento
                                                </label>
                                                <div className="upload-area">
                                                    <label
                                                        htmlFor="fotos_edit"
                                                        className={`upload-label ${fotosEditSelected ? 'uploaded' : ''}`}
                                                    >
                                                        <div className="upload-content">
                                                            <i className={`bi ${fotosEditSelected ? 'bi-check-circle-fill text-success' : 'bi-images'} upload-icon`}></i>
                                                            <div className="upload-text">
                                                                <div className="fw-semibold">
                                                                    {fotosEditSelected ? 'Fotos Selecionadas' : 'Selecionar Fotos'}
                                                                </div>
                                                                <small className="text-muted">
                                                                    {fotosEditSelected ? `${arquivosSelecionados.fotos.length} arquivo(s)` : 'Múltiplas imagens'}
                                                                </small>
                                                            </div>
                                                        </div>
                                                        {fotosEditSelected && (
                                                            <div className="upload-badge">
                                                                <span className="badge bg-success">
                                                                    <i className="bi bi-check me-1"></i>
                                                                    {arquivosSelecionados.fotos.length} arquivo(s)
                                                                </span>
                                                            </div>
                                                        )}
                                                    </label>
                                                    <Controller
                                                        control={controlEditarPratica}
                                                        name="fotos"
                                                        render={({ field: { onChange, onBlur, ref } }) => (
                                                            <input
                                                                id="fotos_edit"
                                                                type="file"
                                                                style={{ display: 'none' }}
                                                                multiple
                                                                accept="image/*"
                                                                onBlur={onBlur}
                                                                ref={ref}
                                                                onChange={(e) => {
                                                                    const files = e.target.files;
                                                                    onChange(files);
                                                                    setFotosEditSelected(files && files.length > 0);
                                                                    setArquivosSelecionados(prev => ({
                                                                        ...prev,
                                                                        fotos: files ? Array.from(files) : []
                                                                    }));
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>

                                                {/* Lista de arquivos selecionados */}
                                                {fotosEditSelected && arquivosSelecionados.fotos.length > 0 && (
                                                    <div className="mt-3">
                                                        <div className="selected-files">
                                                            <h6 className="text-success fw-semibold mb-2">
                                                                <i className="bi bi-list-ul me-1"></i>
                                                                Arquivos Selecionados:
                                                            </h6>
                                                            <div className="file-list">
                                                                {arquivosSelecionados.fotos.map((file, index) => (
                                                                    <div key={index} className="file-item">
                                                                        <i className="bi bi-image text-info me-2"></i>
                                                                        <span className="file-name">{file.name}</span>
                                                                        <span className="file-size text-muted">
                                                                            ({(file.size / 1024 / 1024).toFixed(2)} MB)
                                                                        </span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="bg-light border-0 p-4">
                        <div className="d-flex gap-3 w-100">
                            <button
                                type="button"
                                className="btn btn-outline-secondary btn px-2"
                                onClick={() => {
                                    setShowModalEditarPratica(false);
                                    setShowModalVisualizarPratica(true);
                                    setListaPresencaEditSelected(false);
                                    setFotosEditSelected(false);
                                    setArquivosSelecionados({ listaPresenca: null, fotos: [] });
                                }}
                            >
                                <i className="bi bi-x-circle me-2"></i>
                                Cancelar
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary btn px-2 ms-auto"
                                disabled={loadingEditar}
                            >
                                {loadingEditar ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Salvando...
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-check-circle me-2"></i>
                                        Salvar Alterações
                                    </>
                                )}
                            </button>
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal show={showModalConfirmacaoDeletar} onHide={() => {
                setShowModalConfirmacaoDeletar(false);
                if (shouldReopenDetailsModal) {
                    setShowModalVisualizarPratica(true);
                    setShouldReopenDetailsModal(false);
                }
            }} size="lg">
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-5 text-primary">Confirmação</span>
                </Modal.Header>
                <Modal.Body className="bg-gray-100 p-4">
                    <p>Você tem certeza que deseja excluir esta prática?</p>
                    <p className="text-muted">Esta ação não poderá ser desfeita e todos os arquivos associados serão removidos.</p>
                </Modal.Body>
                <Modal.Footer className="justify-content-end">
                    <div className="d-flex justify-content-end">
                        <button
                            type="button"
                            className="btn me-2"
                            onClick={() => {
                                setShowModalConfirmacaoDeletar(false);
                                if (shouldReopenDetailsModal) {
                                    setShowModalVisualizarPratica(true);
                                    setShouldReopenDetailsModal(false);
                                }
                            }}
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={handleDeletarPratica}
                        >
                            Excluir
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={modalVerAvaliacaoReacao.show} onHide={() => setModalVerAvaliacaoReacao({ show: false, tipo: '', data: null })} size="xl">
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">
                        {modalVerAvaliacaoReacao.tipo === 'Avaliação de Reação Híbrida'
                            ? 'Avaliação de Reação Híbrida'
                            : 'Avaliação de Reação'}
                    </span>
                </Modal.Header>
                <Modal.Body>
                    {modalVerAvaliacaoReacao.data && (
                        <div className="container">
                            <div className="row mb-3">
                                <div className="col-12">
                                    <div className="d-flex justify-content-between">
                                        <h5 className="text-primary">{modalVerAvaliacaoReacao.data.nomeModulo}</h5>
                                        <span className="text-muted">Realizada em: {modalVerAvaliacaoReacao.data.data_formatada}</span>
                                    </div>
                                    <hr />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <div className="card mb-3">
                                        <div className="card-body">
                                            <h6 className="card-title text-primary">Respostas</h6>
                                            {modalVerAvaliacaoReacao.data.respostas ? (
                                                <div className="table-responsive">
                                                    <table className="table table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th>Pergunta</th>
                                                                <th>Resposta</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {(() => {
                                                                try {
                                                                    if (modalVerAvaliacaoReacao.tipo === 'Avaliação de Reação' || modalVerAvaliacaoReacao.tipo === 'Avaliação de Reação Híbrida') {
                                                                        // Garantir que questoes e respostas estão em formato adequado
                                                                        const questoes = typeof modalVerAvaliacaoReacao.data.questoes === 'string'
                                                                            ? JSON.parse(modalVerAvaliacaoReacao.data.questoes)
                                                                            : modalVerAvaliacaoReacao.data.questoes;

                                                                        const respostas = typeof modalVerAvaliacaoReacao.data.respostas === 'string'
                                                                            ? JSON.parse(modalVerAvaliacaoReacao.data.respostas)
                                                                            : modalVerAvaliacaoReacao.data.respostas;

                                                                        return Array.isArray(questoes) && Array.isArray(respostas)
                                                                            ? questoes.map((questao, index) => (
                                                                                <tr key={index}>
                                                                                    <td>{questao}</td>
                                                                                    <td>{respostas[index]}</td>
                                                                                </tr>
                                                                            ))
                                                                            : <tr><td colSpan="2">Formato de dados inválido</td></tr>;
                                                                    } else {
                                                                        // Renderização para avaliações normais
                                                                        const respostasObj = typeof modalVerAvaliacaoReacao.data.respostas === 'string'
                                                                            ? JSON.parse(modalVerAvaliacaoReacao.data.respostas)
                                                                            : modalVerAvaliacaoReacao.data.respostas;

                                                                        const questoesObj = typeof modalVerAvaliacaoReacao.data.questoes === 'string'
                                                                            ? JSON.parse(modalVerAvaliacaoReacao.data.questoes)
                                                                            : modalVerAvaliacaoReacao.data.questoes;

                                                                        return Object.entries(respostasObj).map(([perguntaId, resposta], index) => {
                                                                            const questaoTexto = questoesObj[perguntaId]?.questao || `Pergunta ${Number(perguntaId) + 1}`;
                                                                            return (
                                                                                <tr key={index}>
                                                                                    <td>{questaoTexto}</td>
                                                                                    <td>{resposta}</td>
                                                                                </tr>
                                                                            );
                                                                        });
                                                                    }
                                                                } catch (error) {
                                                                    console.error('Erro ao renderizar avaliação:', error);
                                                                    return <tr><td colSpan="2">Erro ao processar os dados: {error.message}</td></tr>;
                                                                }
                                                            })()}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <div className="alert alert-info">
                                                    <i className="bi bi-info-circle me-2"></i>
                                                    Não há detalhes disponíveis para as respostas desta avaliação.
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {modalVerAvaliacaoReacao.data.comentarios && (
                                        <div className="card mb-3">
                                            <div className="card-body">
                                                <h6 className="card-title text-primary">Comentários</h6>
                                                <p>{modalVerAvaliacaoReacao.data.comentarios}</p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={exportarAvaliacaoReacaoExcel}
                    >
                        <i className="bi bi-file-earmark-spreadsheet-fill me-2"></i>
                        Exportar Excel
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={() => setModalVerAvaliacaoReacao({ show: false, tipo: '', data: null })}
                    >
                        Fechar
                    </button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Prática em Massa */}
            <Modal size="xl" show={showModalPraticaMassa} onHide={() => {
                setShowModalPraticaMassa(false);
                setListaPresencaMassaSelected(false);
                setFotosMassaSelected(false);
                setAlunosSelecionadosMassa([]);
            }} backdrop="static">
                <form onSubmit={handleSubmitPraticaMassa(onSubmitPraticaMassa)}>
                    <Modal.Header closeButton>
                        <Modal.Title className="text-center w-100">
                            <span className="d-block fs-6">Registrar Prática em Massa</span>
                            <small className="text-muted">
                                {alunosSelecionadosMassa.length} aluno(s) selecionado(s)
                            </small>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-4 bg-gray-100">
                        <div className="row g-4">
                            {/* Seleção de Alunos */}
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-primary">
                                        <h6 className="mb-0 text-white fw-bold">
                                            <i className="bi bi-person-check me-2"></i>
                                            Selecionar Alunos
                                        </h6>
                                        <small className="text-white">Apenas alunos sem prática registrada aparecem na lista</small>
                                    </div>
                                    <div className="card-body">
                                        <Select
                                            isMulti
                                            styles={customStyles}
                                            options={filterAlunos
                                                .filter(aluno => !praticasRegistradas[aluno.id]?.ativa)
                                                .map(aluno => ({
                                                    value: aluno.id,
                                                    label: `${aluno.nome_completo} (${aluno.codigo})`,
                                                    ...aluno
                                                }))
                                            }
                                            value={alunosSelecionadosMassa}
                                            onChange={setAlunosSelecionadosMassa}
                                            placeholder="Selecione os alunos..."
                                            noOptionsMessage={() => "Nenhum aluno disponível"}
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                        />
                                        {alunosSelecionadosMassa.length === 0 && (
                                            <div className="text-muted mt-2">
                                                <i className="bi bi-info-circle me-1"></i>
                                                Selecione pelo menos um aluno para continuar
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Informações Básicas */}
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-primary">
                                        <h6 className="mb-0 text-white fw-bold">
                                            <i className="bi bi-info-circle me-2"></i>
                                            Informações do Treinamento
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-calendar-event me-1 text-primary"></i>
                                                    Data do Treinamento Prático
                                                </label>
                                                <input
                                                    type="datetime-local"
                                                    className={`form-control form-control ${errorsPraticaMassa.data_treinamento ? 'is-invalid' : ''}`}
                                                    {...registerPraticaMassa('data_treinamento', {
                                                        required: true
                                                    })}
                                                />
                                                {errorsPraticaMassa.data_treinamento && <div className="invalid-feedback">Campo obrigatório</div>}
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-geo-alt me-1 text-primary"></i>
                                                    Local do Treinamento
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control ${errorsPraticaMassa.local_treinamento ? 'is-invalid' : ''}`}
                                                    {...registerPraticaMassa('local_treinamento', {
                                                        required: true
                                                    })}
                                                />
                                                {errorsPraticaMassa.local_treinamento && <div className="invalid-feedback">Campo obrigatório</div>}
                                            </div>
                                            <div className="col-12">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-person-badge me-1 text-primary"></i>
                                                    Instrutor Responsável
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control ${errorsPraticaMassa.gestor ? 'is-invalid' : ''}`}
                                                    {...registerPraticaMassa('gestor', {
                                                        required: true
                                                    })}
                                                />
                                                {errorsPraticaMassa.gestor && <div className="invalid-feedback">Campo obrigatório</div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Upload de Arquivos */}
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-primary">
                                        <h6 className="mb-0 text-white fw-bold">
                                            <i className="bi bi-cloud-upload me-2"></i>
                                            Arquivos do Treinamento
                                        </h6>
                                        <small className="text-white">Os mesmos arquivos serão aplicados a todos os alunos selecionados</small>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-4">
                                            {/* Lista de Presença */}
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-file-earmark-text me-1 text-success"></i>
                                                    Lista de Presença
                                                </label>
                                                <div className="upload-area">
                                                    <label
                                                        htmlFor="lista_presenca_massa"
                                                        className={`upload-label ${listaPresencaMassaSelected ? 'uploaded' : ''}`}
                                                    >
                                                        <div className="upload-content">
                                                            <i className={`bi ${listaPresencaMassaSelected ? 'bi-check-circle-fill text-success' : 'bi-file-earmark-plus'} upload-icon`}></i>
                                                            <div className="upload-text">
                                                                <div className="fw-semibold">
                                                                    {listaPresencaMassaSelected ? 'Arquivo Selecionado' : 'Selecionar Lista de Presença'}
                                                                </div>
                                                                <small className="text-muted">PDF ou Imagem</small>
                                                            </div>
                                                        </div>
                                                        {listaPresencaMassaSelected && (
                                                            <div className="upload-badge">
                                                                <span className="badge bg-success">
                                                                    <i className="bi bi-check me-1"></i>
                                                                    1 arquivo
                                                                </span>
                                                            </div>
                                                        )}
                                                    </label>
                                                    <Controller
                                                        control={controlPraticaMassa}
                                                        name="lista_presenca"
                                                        rules={{
                                                            required: true
                                                        }}
                                                        render={({ field: { onChange, onBlur, ref } }) => (
                                                            <input
                                                                id="lista_presenca_massa"
                                                                type="file"
                                                                style={{ display: 'none' }}
                                                                accept=".pdf,image/*"
                                                                onBlur={onBlur}
                                                                ref={ref}
                                                                onChange={(e) => {
                                                                    const files = e.target.files;
                                                                    onChange(files);
                                                                    setListaPresencaMassaSelected(files && files.length > 0);
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                                {errorsPraticaMassa.lista_presenca && <div className="invalid-feedback d-block">Campo obrigatório</div>}
                                            </div>

                                            {/* Fotos */}
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-images me-1 text-info"></i>
                                                    Fotos do Treinamento
                                                </label>
                                                <div className="upload-area">
                                                    <label
                                                        htmlFor="fotos_massa"
                                                        className={`upload-label ${fotosMassaSelected ? 'uploaded' : ''}`}
                                                    >
                                                        <div className="upload-content">
                                                            <i className={`bi ${fotosMassaSelected ? 'bi-check-circle-fill text-success' : 'bi-images'} upload-icon`}></i>
                                                            <div className="upload-text">
                                                                <div className="fw-semibold">
                                                                    {fotosMassaSelected ? 'Fotos Selecionadas' : 'Selecionar Fotos'}
                                                                </div>
                                                                <small className="text-muted">Múltiplas imagens</small>
                                                            </div>
                                                        </div>
                                                        {fotosMassaSelected && (
                                                            <div className="upload-badge">
                                                                <span className="badge bg-success">
                                                                    <i className="bi bi-check me-1"></i>
                                                                    Arquivos selecionados
                                                                </span>
                                                            </div>
                                                        )}
                                                    </label>
                                                    <Controller
                                                        control={controlPraticaMassa}
                                                        name="fotos"
                                                        rules={{
                                                            required: true
                                                        }}
                                                        render={({ field: { onChange, onBlur, value, ref } }) => (
                                                            <input
                                                                id="fotos_massa"
                                                                type="file"
                                                                style={{ display: 'none' }}
                                                                multiple
                                                                accept="image/*"
                                                                onBlur={onBlur}
                                                                ref={ref}
                                                                onChange={(e) => {
                                                                    const files = e.target.files;
                                                                    onChange(files);
                                                                    setFotosMassaSelected(files && files.length > 0);
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                                {errorsPraticaMassa.fotos && <div className="invalid-feedback d-block">Campo obrigatório</div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-center">
                        <button
                            type="button"
                            className="btn btn-outline-secondary me-2"
                            onClick={() => {
                                setShowModalPraticaMassa(false);
                                setListaPresencaMassaSelected(false);
                                setFotosMassaSelected(false);
                                setAlunosSelecionadosMassa([]);
                            }}
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="btn btn-primary text-white"
                            disabled={loadingRegistrarMassa || alunosSelecionadosMassa.length === 0}
                        >
                            {loadingRegistrarMassa ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                    Registrando...
                                </>
                            ) : (
                                <>
                                    <i className="bi bi-check-circle me-2"></i>
                                    Registrar para {alunosSelecionadosMassa.length} aluno(s)
                                </>
                            )}
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>

            {/* Modal de Histórico do Aluno */}
            <Modal size="xl" show={showModalHistorico} onHide={() => {
                setShowModalHistorico(false);
                setHistoricoAluno(null);
                setTabAtivaHistorico('aulas');
            }}>
                <Modal.Header closeButton>
                    <Modal.Title className="text-center w-100">
                        <span className="d-block fs-6">{usuarioSelecionado.nome_completo}</span>
                        <small className="text-muted">Histórico do Aluno</small>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4 bg-gray-100">
                    {loadingHistorico ? (
                        <div className="d-flex justify-content-center align-items-center p-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Carregando...</span>
                            </div>
                        </div>
                    ) : historicoAluno ? (
                        <>
                            {/* Tabs de navegação */}
                            <ul className="nav nav-tabs" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link ${tabAtivaHistorico === 'aulas' ? 'active' : ''}`}
                                        onClick={() => setTabAtivaHistorico('aulas')}
                                    >
                                        <i className="bi bi-play-circle me-2"></i>
                                        <span className="d-none d-md-inline">Aulas </span>
                                        ({historicoAluno.aulas?.length || 0})
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link ${tabAtivaHistorico === 'avaliacoes' ? 'active' : ''}`}
                                        onClick={() => setTabAtivaHistorico('avaliacoes')}
                                    >
                                        <i className="bi bi-file-text me-2"></i>
                                        <span className="d-none d-md-inline">Avaliações </span>
                                        ({historicoAluno.avaliacoes?.length || 0})
                                    </button>
                                </li>
                                {dataInfoCurso[0]?.tipo === 'misto' && (
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${tabAtivaHistorico === 'praticas' ? 'active' : ''}`}
                                            onClick={() => setTabAtivaHistorico('praticas')}
                                        >
                                            <i className="bi bi-person-workspace me-2"></i>
                                            <span className="d-none d-md-inline">Práticas </span>
                                            ({historicoAluno.praticas?.length || 0})
                                        </button>
                                    </li>
                                )}
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link ${tabAtivaHistorico === 'reacao' ? 'active' : ''}`}
                                        onClick={() => setTabAtivaHistorico('reacao')}
                                    >
                                        <i className="bi bi-chat-dots me-2"></i>
                                        <span className="d-none d-md-inline">Reação </span>
                                        ({historicoAluno.avaliacoes_reacao?.length || 0})
                                    </button>
                                </li>
                            </ul>

                            {/* Conteúdo das tabs */}
                            <div className="tab-content">
                                {/* Tab Aulas */}
                                {tabAtivaHistorico === 'aulas' && (
                                    <>
                                        {/* Versão Desktop */}
                                        <div className="d-none d-md-block">
                                            <div className="table-full-width mt-3 mb-3">
                                                <div className="table-responsive">
                                                    <table className="table align-middle mt-1">
                                                        <thead>
                                                            <tr className='text-nowrap'>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted'>Módulo</th>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted'>Aula</th>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted text-center'>Data</th>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted text-center'>Status</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {historicoAluno.aulas && historicoAluno.aulas.length > 0 ? (
                                                                historicoAluno.aulas.map((aula, index) => {
                                                                    const rowClass = index % 2 === 0 ? 'even-row' : 'odd-row';
                                                                    return (
                                                                        <tr key={index} className={rowClass}>
                                                                            <td className="fw-semibold">{aula.nomeModulo}</td>
                                                                            <td>{aula.nomeAula}</td>
                                                                            <td className="text-center">{aula.data_formatada}</td>
                                                                            <td className="text-center">
                                                                                <span className={`badge bg-${aula.arquivado ? 'secondary' : 'success'}`}>
                                                                                    {aula.arquivado ? 'Arquivado' : 'Ativo'}
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="4" className="text-center text-muted py-4">
                                                                        Nenhuma aula registrada
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Versão Mobile */}
                                        <div className="d-md-none">
                                            {historicoAluno.aulas && historicoAluno.aulas.length > 0 ? (
                                                <div className="row">
                                                    {historicoAluno.aulas.map((aula, index) => (
                                                        <div key={index} className="col-12 mb-2">
                                                            <div className="card border-0 shadow-sm rounded-3">
                                                                <div className="card-body p-3">
                                                                    <h6 className="fw-semibold text-primary mb-2">{aula.nomeModulo}</h6>
                                                                    <div className="mb-2">
                                                                        <small className="text-muted d-block mb-1">Aula</small>
                                                                        <span>{aula.nomeAula}</span>
                                                                    </div>
                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                        <div>
                                                                            <small className="text-muted d-block mb-1">Data</small>
                                                                            <span>{aula.data_formatada}</span>
                                                                        </div>
                                                                        <div>
                                                                            <small className="text-muted d-block mb-1">Status</small>
                                                                            <span className={`badge bg-${aula.arquivado ? 'secondary' : 'success'}`}>
                                                                                {aula.arquivado ? 'Arquivado' : 'Ativo'}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <p className="text-center text-muted py-4">Nenhuma aula registrada</p>
                                            )}
                                        </div>
                                    </>
                                )}

                                {/* Tab Avaliações */}
                                {tabAtivaHistorico === 'avaliacoes' && (
                                    <>
                                        {/* Versão Desktop */}
                                        <div className="d-none d-md-block">
                                            <div className="table-full-width mt-3 mb-3">
                                                <div className="table-responsive">
                                                    <table className="table align-middle mt-1">
                                                        <thead>
                                                            <tr className='text-nowrap'>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted'>Módulo</th>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted text-center'>Tipo</th>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted text-center'>Nota</th>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted text-center'>Data</th>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted text-center'>Status</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {historicoAluno.avaliacoes && historicoAluno.avaliacoes.length > 0 ? (
                                                                historicoAluno.avaliacoes.map((avaliacao, index) => {
                                                                    const rowClass = index % 2 === 0 ? 'even-row' : 'odd-row';
                                                                    return (
                                                                        <tr key={index} className={rowClass}>
                                                                            <td className="fw-semibold">{avaliacao.nomeModulo || avaliacao.nomeAvaliacaoExtra}</td>
                                                                            <td className="text-center">
                                                                                <span className="badge bg-info">{avaliacao.tipo}</span>
                                                                            </td>
                                                                            <td className={`text-center fw-bold ${avaliacao.nota < 6 ? 'text-primary' : 'text-dark'}`}>
                                                                                {avaliacao.nota || 'N/A'}
                                                                            </td>
                                                                            <td className="text-center">{avaliacao.data_formatada}</td>
                                                                            <td className="text-center">
                                                                                <span className={`badge bg-${avaliacao.arquivado ? 'secondary' : 'success'}`}>
                                                                                    {avaliacao.arquivado ? 'Arquivado' : 'Ativo'}
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="5" className="text-center text-muted py-4">
                                                                        Nenhuma avaliação registrada
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Versão Mobile */}
                                        <div className="d-md-none">
                                            {historicoAluno.avaliacoes && historicoAluno.avaliacoes.length > 0 ? (
                                                <div className="row">
                                                    {historicoAluno.avaliacoes.map((avaliacao, index) => (
                                                        <div key={index} className="col-12 mb-2">
                                                            <div className="card border-0 shadow-sm rounded-3">
                                                                <div className="card-body p-3">
                                                                    <h6 className="fw-semibold text-primary mb-2">{avaliacao.nomeModulo || avaliacao.nomeAvaliacaoExtra}</h6>
                                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                                        <div>
                                                                            <small className="text-muted d-block mb-1">Tipo</small>
                                                                            <span className="badge bg-info">{avaliacao.tipo}</span>
                                                                        </div>
                                                                        <div className="text-end">
                                                                            <small className="text-muted d-block mb-1">Nota</small>
                                                                            <span className={`fw-bold ${avaliacao.nota < 6 ? 'text-primary' : 'text-dark'}`}>
                                                                                {avaliacao.nota || 'N/A'}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                        <div>
                                                                            <small className="text-muted d-block mb-1">Data</small>
                                                                            <span>{avaliacao.data_formatada}</span>
                                                                        </div>
                                                                        <div>
                                                                            <small className="text-muted d-block mb-1">Status</small>
                                                                            <span className={`badge bg-${avaliacao.arquivado ? 'secondary' : 'success'}`}>
                                                                                {avaliacao.arquivado ? 'Arquivado' : 'Ativo'}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <p className="text-center text-muted py-4">Nenhuma avaliação registrada</p>
                                            )}
                                        </div>
                                    </>
                                )}

                                {/* Tab Práticas */}
                                {tabAtivaHistorico === 'praticas' && (
                                    <>
                                        {/* Versão Desktop */}
                                        <div className="d-none d-md-block">
                                            <div className="table-full-width mt-3 mb-3">
                                                <div className="table-responsive">
                                                    <table className="table align-middle mt-1">
                                                        <thead>
                                                            <tr className='text-nowrap'>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted'>Data do Treinamento</th>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted'>Local</th>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted'>Gestor</th>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted text-center'>Data de Registro</th>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted text-center'>Status</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {historicoAluno.praticas && historicoAluno.praticas.length > 0 ? (
                                                                historicoAluno.praticas.map((pratica, index) => {
                                                                    const rowClass = index % 2 === 0 ? 'even-row' : 'odd-row';
                                                                    return (
                                                                        <tr key={index} className={rowClass}>
                                                                            <td>
                                                                                {new Date(pratica.data_treinamento).toLocaleDateString('pt-BR', {
                                                                                    day: '2-digit',
                                                                                    month: '2-digit',
                                                                                    year: 'numeric',
                                                                                    hour: '2-digit',
                                                                                    minute: '2-digit'
                                                                                })}
                                                                            </td>
                                                                            <td>{pratica.local_treinamento}</td>
                                                                            <td>{pratica.gestor}</td>
                                                                            <td className="text-center">{pratica.data_formatada}</td>
                                                                            <td className="text-center">
                                                                                <span className={`badge bg-${pratica.arquivado ? 'secondary' : 'success'}`}>
                                                                                    {pratica.arquivado ? 'Arquivado' : 'Ativo'}
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="5" className="text-center text-muted py-4">
                                                                        Nenhuma prática registrada
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Versão Mobile */}
                                        <div className="d-md-none">
                                            {historicoAluno.praticas && historicoAluno.praticas.length > 0 ? (
                                                <div className="row">
                                                    {historicoAluno.praticas.map((pratica, index) => (
                                                        <div key={index} className="col-12 mb-2">
                                                            <div className="card border-0 shadow-sm rounded-3">
                                                                <div className="card-body p-3">
                                                                    <div className="mb-2">
                                                                        <small className="text-muted d-block mb-1">Data do Treinamento</small>
                                                                        <span>
                                                                            {new Date(pratica.data_treinamento).toLocaleDateString('pt-BR', {
                                                                                day: '2-digit',
                                                                                month: '2-digit',
                                                                                year: 'numeric',
                                                                                hour: '2-digit',
                                                                                minute: '2-digit'
                                                                            })}
                                                                        </span>
                                                                    </div>
                                                                    <div className="mb-2">
                                                                        <small className="text-muted d-block mb-1">Local</small>
                                                                        <span>{pratica.local_treinamento}</span>
                                                                    </div>
                                                                    <div className="mb-2">
                                                                        <small className="text-muted d-block mb-1">Gestor</small>
                                                                        <span>{pratica.gestor}</span>
                                                                    </div>
                                                                    <div className="d-flex justify-content-between align-items-center pt-2 border-top">
                                                                        <div>
                                                                            <small className="text-muted d-block mb-1">Data de Registro</small>
                                                                            <span>{pratica.data_formatada}</span>
                                                                        </div>
                                                                        <div>
                                                                            <small className="text-muted d-block mb-1">Status</small>
                                                                            <span className={`badge bg-${pratica.arquivado ? 'secondary' : 'success'}`}>
                                                                                {pratica.arquivado ? 'Arquivado' : 'Ativo'}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <p className="text-center text-muted py-4">Nenhuma prática registrada</p>
                                            )}
                                        </div>
                                    </>
                                )}

                                {/* Tab Avaliações de Reação */}
                                {tabAtivaHistorico === 'reacao' && (
                                    <>
                                        {/* Versão Desktop */}
                                        <div className="d-none d-md-block">
                                            <div className="table-full-width mt-3 mb-3">
                                                <div className="table-responsive">
                                                    <table className="table align-middle mt-1">
                                                        <thead>
                                                            <tr className='text-nowrap'>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted'>Módulo</th>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted text-center'>Tipo</th>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted text-center'>Data</th>
                                                                <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted text-center'>Status</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {historicoAluno.avaliacoes_reacao && historicoAluno.avaliacoes_reacao.length > 0 ? (
                                                                historicoAluno.avaliacoes_reacao.map((reacao, index) => {
                                                                    const rowClass = index % 2 === 0 ? 'even-row' : 'odd-row';
                                                                    return (
                                                                        <tr key={index} className={rowClass}>
                                                                            <td className="fw-semibold">{reacao.nomeModulo}</td>
                                                                            <td className="text-center">
                                                                                <span className="badge bg-primary">{reacao.tipo}</span>
                                                                            </td>
                                                                            <td className="text-center">{reacao.data_formatada}</td>
                                                                            <td className="text-center">
                                                                                <span className={`badge bg-${reacao.arquivado ? 'secondary' : 'success'}`}>
                                                                                    {reacao.arquivado ? 'Arquivado' : 'Ativo'}
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="4" className="text-center text-muted py-4">
                                                                        Nenhuma avaliação de reação registrada
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Versão Mobile */}
                                        <div className="d-md-none">
                                            {historicoAluno.avaliacoes_reacao && historicoAluno.avaliacoes_reacao.length > 0 ? (
                                                <div className="row">
                                                    {historicoAluno.avaliacoes_reacao.map((reacao, index) => (
                                                        <div key={index} className="col-12 mb-2">
                                                            <div className="card border-0 shadow-sm rounded-3">
                                                                <div className="card-body p-3">
                                                                    <h6 className="fw-semibold text-primary mb-2">{reacao.nomeModulo}</h6>
                                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                                        <div>
                                                                            <small className="text-muted d-block mb-1">Tipo</small>
                                                                            <span className="badge bg-primary">{reacao.tipo}</span>
                                                                        </div>
                                                                        <div>
                                                                            <small className="text-muted d-block mb-1">Status</small>
                                                                            <span className={`badge bg-${reacao.arquivado ? 'secondary' : 'success'}`}>
                                                                                {reacao.arquivado ? 'Arquivado' : 'Ativo'}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <small className="text-muted d-block mb-1">Data</small>
                                                                        <span>{reacao.data_formatada}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <p className="text-center text-muted py-4">Nenhuma avaliação de reação registrada</p>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        </>
                    ) : (
                        <div className="alert alert-info">
                            <i className="bi bi-info-circle me-2"></i>
                            Não foi possível carregar o histórico do aluno.
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <button
                        className="btn btn-outline-primary"
                        onClick={() => {
                            setShowModalHistorico(false);
                            setHistoricoAluno(null);
                            setTabAtivaHistorico('aulas');
                        }}
                    >
                        Fechar
                    </button>
                </Modal.Footer>
            </Modal>

        </>
    )
}

export default ListaAlunos;